import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonService } from '../../../commons/services/common.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { DragulaService } from 'ng2-dragula';
import { GestionClient } from '../../../recylog/application/gestion.client';
import { ConstanteEcorec } from '../../../recylog/application/constante.ecorec';
import { GestionFormat } from '../../../recylog/application/gestion.format';

import * as moment from 'moment';
import { timeStamp } from 'console';
import { element } from 'protractor';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-detail-devis',
  templateUrl: './detail-devis.component.html',
  styleUrls: ['./detail-devis.component.css']
})
export class DetailDevisComponent implements OnInit {
  @Input() devis;
  @Input() type;
  @Input() bonachat;
  @ViewChild('ficheC') ficheC;
  @Input() add;
  @Input() openId;
  @Input() client;
  @Input() noteditable;
  @Input() isDepuisFacturation;
  @Input() codeExterne;
  @Output() hidefunction = new EventEmitter<any>();
  @Output() ficheclient = new EventEmitter<any>();
  @Output() reloadbon = new EventEmitter<any>();
  @Output() actualiseListe = new EventEmitter<any>();
  @Output() createClientAppel = new EventEmitter<any>();


  detail = {};
  etatBon = 1;
  default = 0;
  nbdigit;
  dataArticle = [];
  dataContact = [];
  isEditChp = {};
  classPresta: String = 'detailfact ';
  isEdit: Boolean = false;
  showPied: Boolean = false;
  adresseAchat: Boolean = false;
  isEmpty: Boolean = true;
  defaultRem: String = '%';
  devise;
  timeout;
  result = [];
  modepaie;
  pays = '';
  mindropdown = 'mindropdown';
  formatPerso = [];
  formatprs: String = '';
  selectedFpFIP: any = {};
  typeFIP: any = 0;
  typeImp = true;
  listeSite;
  listeZone;
  listeAffaire;
  listChantier = [];
  listDoc = [];
  condition1: Boolean = false;
  condition2: Boolean = false;
  condition3: Boolean = false;
  viewFull: Boolean = false;
  showMore: Boolean = false;
  prixNego: Boolean = false;
  error = '';
  listUser = [];
  etat;
  focusIndex = 0;
  idFocus: any = 0;
  indexSection = 0;
  selectedSection: any = {};
  renderTable: Boolean = true;
  // enableButtonAddLigne: Boolean = true;
  // enableButtonInsertLigne: Boolean = true;
  dataModel2 = [];
  subs = new Subscription();
  searchTable = ['clients'];
  dupClientSelected;
  selected = [];
  listeMotifRefusDevis = [];
  indexListLignes = 0;
  dataMotifCreationDevis = [];
  motifCreationDevis;
  isGestionAffaire: Boolean = false;
  article_prix_nego = '';
  listLignesTraiterPrixNego = [];
  listLibelleNegocier = [];
  isCreerPNZero = false;

  showcht: Boolean = false;
  isEditCht: Boolean = false;
  createCht: Boolean = false;
  showContact: Boolean = false;
  isAddContact: Boolean = false;
  isToogle: Boolean = false;
  isTooglePrestationEcoloc: Boolean = false;
  chantier = {};
  infoContenant: any = {};
  infoContenantCopy: any = {};
  objProspect: any = {};
  planning: any = {};

  isDesactiverFormatStandardDevis = false;
  checkedall: Boolean = true;
  listContenant = [];
  listAgence = [];
  listSection = [];
  clientProsp: any = {}
  visibiliteValue = 1;
  choixVisibilite: any[] = [
    { id: 1, libelle: 'Tous les modules' },
    { id: 2, libelle: 'Tous les modules sauf Ecopol' },
    { id: 3, libelle: 'Définir' }
  ];
  listModules: any[] = [];
  artContenu: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  rowToExpand;
  indexLigneDevisCreateMvt = 0;
  indexNbBenneCreateMvt = 0;
  r_checkArticleDepotsDevis;
  nbBennes;
  descriptionDialogueNbBenne = '';

  indexLigneDevisCreatePrestation = 0;
  listPrestation = [];
  listArtPrest = [];

  listFIP = {};

  // Pour l'envoi par mail
  datamail: any = {};
  societe = {};
  siteUtilisateur = {};
  user;
  indexBonEnvoiParMail = 0;
  devisAEnvoyerParMailCourant;
  envoiemail_mail = '';
  envoiemail_adrEmailFact = '';
  envoiemail_f;
  envoiemail_adrDestClient = '';
  envoiemail_format = '';
  // envoiemail_isFactNormale = false;
  envoiemail_signatureTexte = '';
  envoiemail_signatureImageTemp = '';
  envoiemail_signatureImage = '';
  // envoiemail_factureAEnvoyer;
  envoiemail_formatImpressionParEmail;
  envoiemail_finalSignatureImage = '';
  envoiemail_strSignatureTexte = '';
  envoiemail_expMail = '';
  envoiemail_copieMail = '';
  envoiemail_titreMail = '';
  envoiemail_corpsMail = '';
  envoiemail_destMail = '';
  SUJET_MAIL_DEVIS_ECOCRM = '[ECOREC] Devis '
    + '@numDevisEcocrm de la soci\u00e9t\u00e9 @nomSociete';
  CONTENU_MAIL_DEVIS_ECOCRM = '\nBonjour,\n\nVeuillez trouver ci-joint '
    + 'le devis num\u00e9ro @numDevisEcocrm '
    + 'de la soci\u00e9t\u00e9 @nomSociete.\n\nCordialement,'
    + '\n@nomSociete.\n\n            '
    + '@signatureTexteEcocrmDevis \n\n';
  envoiemail_strDevis;
  envoiemail_strType;
  envoiemail_strNumDevis;
  envoiemail_strNomSociete;
  envoimail_siteEntrepriseAdresseExpDevis;
  envoimail_siteEntrepriseAdresseCopieDevis;
  envoimail_siteEntrepriseTitreMailDevis;
  envoimail_siteEntrepriseCorpsMailDevis;
  isEnvoiParEmail = false;
  aUnSignature = false;
  listeSociete = [];
  isDroitCreerDevis = false;
  isDroitModifDevis = false;
  isDroitHistoDevis = false;
  isClientBloquer = false;
  ligneAffiche = [];

  accepteDevisMail: Boolean = false;
  isClick: Boolean = false;
  LISTE_CLEF_MOUV = [];

  @ViewChild('mail') mail;
  @ViewChild('CRMail') CRMail;
  @ViewChild('loading') loading;
  @ViewChild('myTable') table: any;
  @ViewChild('format') format;
  @ViewChild('formatCAP') formatCAP;
  @ViewChild('msg') msg;
  @ViewChild('msgMail') msgMail;
  @ViewChild('msgMailCR') msgMailCR;
  @ViewChild('dialogueDupliquer') dialogueDupliquer;
  @ViewChild('searchClientDupliquer') searchClientDupliquer;
  @ViewChild('dialogueDmdMotifRefus') dialogueDmdMotifRefus;
  @ViewChild('dialoguePrixNego') dialoguePrixNego;
  @ViewChild('dialoguePNZero') dialoguePNZero;
  @ViewChild('dialogueLibelleNego') dialogueLibelleNego;
  @ViewChild('dialogueCodeClient') dialogueCodeClient;
  @ViewChild('visibilite') visibilite;
  @ViewChild('dialogueNbBenne') dialogueNbBenne;
  @ViewChild('testCreationMouvement') testCreationMouvement;
  @ViewChild('codeClientProspect') codeClientProspect;
  @ViewChild('confirmeAccepteDevis') confirmeAccepteDevis;
  @ViewChild('dialoguePrestationEcoloc') dialoguePrestationEcoloc;

  formatPersoCAP = [];
  formatprsCAP: String = '';
  isDesactiverFormatStandardCAP: Boolean = false;
  disabledAccepterBtn: Boolean = false;

  // Tampon pour appel du méthode serviceValidDevis(listLigneDevisTmp, isVideFiltre)
  listLigneDevisTmp = [];
  isVideFiltre = false;

  isDD: Boolean = false;
  devisFIP: any = {};
  @ViewChild('gestFIP') gestFIP;
  @ViewChild('formatPesroFIP') formatPesroFIP;
  @ViewChild('confirmaFIPDND') confirmaFIPDND;
  @ViewChild('confirmaFIPDD') confirmaFIPDD;
  @ViewChild('formatPesroFIPMail') formatPesroFIPMail;

  constructor(protected common: CommonService, private modalService: BsModalService, private dragulaService: DragulaService) {
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.devise = this.common.local.getObject('paramSociete').devise;
    this.adresseAchat = this.common.local.getObject('paramSociete').adresseAchat;
  }

  ngOnInit() {
    this.user = this.common.local.getObject('userDetail') || {};
    this.isDroitCreerDevis = (this.user.clefDroit3 & 0x00000004) !== 0 ? true : false;
    this.isDroitModifDevis = (this.user.clefDroit3 & 0x00000008) !== 0 ? true : false;
    this.isDroitHistoDevis = (this.user.clefDroit3 & 0x00000010) !== 0 ? true : false;

    if (this.openId) {
      this.isDroitCreerDevis = true;
      this.isDroitModifDevis = true;
    }

    this.siteUtilisateur = this.common.getType('siteUtilisateur');
    this.societe = this.common.local.getObject('paramSociete');
    if (this.common.isProspectHolding) {
      this.searchTable = ['clients', 'prospectHolding'];
      this.getSocieteFille();
    }

    $('.popover').popover('hide');
    this.isGestionAffaire = this.common.local.getObject('paramSociete').gestionAffaire;
    this.isDesactiverFormatStandardDevis = this.common.isDesactiverFormatStandard(this.common.TYPE_FORMAT_PARAMETRABLE_DEVIS);
    this.isDesactiverFormatStandardCAP = this.common.isDesactiverFormatStandardCAP(this.common.TYPE_FORMAT_PARAMETRABLE_CAP);
    this.listeSite = this.common.local.getObject('listeSite') || [];
    this.searchMotifCreationDevis('');
    if (!this.listeSite) {
      this.getListeSite();
    }

    if (!this.listeZone) {
      this.getListeZone();
    }

    if (this.isGestionAffaire && !this.listeAffaire) {
      this.getListeAffaire();
    }

    this.searchContenant();
    this.searchAgence();
    this.getListSection();

    if (!this.add) {
      this.dataMotifCreationDevis.forEach(elt => {
        if (this.devis['motifCreationDevis'] && this.devis['motifCreationDevis'].id === elt.id) {
          this.devis['motifCreationDevis'] = elt;
        }
      });
      this.getDetail(this.devis).then(data => {
        this.motifCreationDevis = this.devis['motifCreationDevis'] ? this.common.getItem(this.common.getType('listMotifCreationDevis'),
          (this.devis['motifCreationDevis'].id || 0)) : '';
        this.isEmpty = false;
        this.detail['isHisto'] = this.noteditable ? this.noteditable : this.detail['isHisto'];
        if (this.codeExterne) {
          this.detail['codeExterne'] = this.codeExterne;
        }

        this.detail['chantier'] = this.detail['chantier'] || { id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' };
        this.detail['zone'] = this.detail['zone'] || { id: 0, libelle: 'Toutes', libelleObjetEntite: 'Toutes' };
        this.detail['listLignes'] = this.detail['listLignes'] || [];
        this.detail['listLignes'].forEach(ligne => {
          if (this.societe['gestionFIP']) {
            if ((ligne.fipDD && ligne.fipDD.id && !ligne.fipDD.signee) || (ligne.fipDND && ligne.fipDND.id && !ligne.fipDND.signee)) {
              ligne.accept = false;
            } else if ((ligne.fipDD && ligne.fipDD.id && ligne.fipDD.signee) || (ligne.fipDND && ligne.fipDND.id && ligne.fipDND.signee)) {
              ligne.accept = true;
            }
          }
          ligne.isTarifQte = ligne.isTarifQte || false;

          if (ligne.article) {
            ligne.article.isTarifQte = ligne.isTarifQte;
          }
        });

        console.log(this.detail['listLignes'])
        /*if (this.detail['chantier']) {
          this.getDetailChantier(this.detail['chantier']);
        }*/
        this.modifDevis();

        if (this.detail['client'] && this.detail['client']['codeBlocage'] && (this.detail['client']['codeBlocage'] === 3 || this.detail['client']['codeBlocage'] === 4 ||
          this.detail['client']['codeBlocage'] === 5 || this.detail['client']['codeBlocage'] === 10)) {
          this.isClientBloquer = true;
        }
      });
    } else {

      this.detail['id'] = 1;
      this.detail['client'] = this.client;
      this.detail['chantier'] = { id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' };
      this.detail['zone'] = { id: 0, libelle: 'Toutes', libelleObjetEntite: 'Toutes' };

      if (this.openId && !this.detail['client'] || (this.detail['client'] && !this.detail['client'].id)) {
        this.detail['client'] = {
          id: 0
        }
      }
      this.detail['listLignes'] = [];
      this.isEmpty = false;
      if (this.codeExterne) {
        this.detail['codeExterne'] = this.codeExterne;
      }

      const dureeValiditeDevis = this.societe['dureeValiditeDevis'] || 3;

      this.detail['dateCreation'] = moment().format('DD/MM/YYYY');
      this.detail['dateFinValidite'] = moment().add(dureeValiditeDevis, 'months').format('DD/MM/YYYY');
      this.detail['datePrevisionnelle'] = moment().add(3, 'months').format('DD/MM/YYYY');
      this.detail['dateCreationModel'] = this.common.parseDate(moment().format('DD/MM/YYYY'));
      this.detail['dateFinValiditeModel'] = this.common.parseDate(moment().add(dureeValiditeDevis, 'months').format('DD/MM/YYYY'));
      this.detail['datePrevisionnelleModel'] = this.common.parseDate(moment().add(3, 'months').format('DD/MM/YYYY'));
      this.listeSite.forEach(elt => {
        elt.libelleObjetEntite = elt.nom;
        if (elt.id === this.common.user[2]) {
          this.detail['sitePrest'] = elt;
          this.detail['siteCA'] = elt;
        }
      });
      this.isEdit = true;

      // positionner commercial par défaut
      this.common.getType('typeCom').forEach(elt => {
        elt.libelleObjetEntite = elt.libelle || '';
        elt.nom = elt.libelle || '';
        if (elt.id === parseInt(this.common.user[0], 10)) {
          this.detail['user'] = elt;
        }
      });

    }

    // this.detail['articleContenantContenu'] = this.selectedRow.articleContenu || this.artContenu[0];
    this.getListModule();
    $('#defaultfocus').focus();
  }

  getListModule() {
    const param = {
      'servlet': 'DBGetListModule',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': []
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.listModules = datas.data;
      }
    });
  }

  changeVisibilite(elem) {
    if (elem !== 3) {
      this.listModules.forEach(elt => elt.checked = false);
      this.detail['client']['listModule'] = [];
    } else {
      this.detail['client']['listModule'] = [
        { id: ConstanteEcorec.MODULE_ECOCRM },
        { id: ConstanteEcorec.MODULE_ECOBENNES },
        { id: ConstanteEcorec.MODULE_ECODECHET },
        { id: ConstanteEcorec.MODULE_ECOFACT },
      ];
      if (this.detail['client']['visibilite'] && this.detail['client']['visibilite'].id === 3) {
        this.listModules.forEach(elt => {
          this.detail['client']['listModule'].forEach(e => {
            if (e.id === elt.id) {
              elt.checked = true;
            }
          });
        });
      }
    }
  }

  showChantier() {
    this.showcht = !this.showcht;
  }

  showFicheContact() {
    this.showContact = !this.showContact;
    if (!this.showContact) {
      this.isEditChp = {};
    }
  }


  closeCht() {
    this.showcht = false;
    this.isEditCht = false;
    this.createCht = false;
    this.chantier = {};
    this.isEditChp = {};
  }

  editChantier(cht?) {
    this.showChantier();
    this.isEditCht = !this.isEditCht;
    this.chantier = cht || {};
  }

  addChantier() {
    this.showChantier();
    this.createCht = !this.createCht;
    this.chantier = {};
  }

  getDetailChantier(event, test?) {
    if (!this.detail['client'].prospectHolding) {
      const param = {
        'servlet': 'DBGetChantier',
        'module': 'Recylog',
        'type': 'tableau',
        'compression': 'false',
        'data': ['DBGetChantier', event.id]
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          this.chantier = datas.data[0];
          this.detail['chantier'] = datas.data[0];
          if (!test) {
            this.editChantier(this.chantier);
          }
          $('.fiche').trigger('click');
        }
      });
    } else {
      this.detail['chantier'] = event;
    }

  }

  createChantier(event) {
    event.nomclass = 'Chantier';
    event.siteChantier = {
      id: this.common.user[2]
    };

    if (!this.detail['client'].prospectHolding) {
      const param = {
        'servlet': 'DBSaveChantierHolding',
        'module': 'Recylog',
        'type': 'liste',
        'compression': 'false',
        'data': [['DBSaveChantierHolding'], event, {
          id: this.detail['client'].id,
          nomclass: 'Client'
        }]
      };

      this.common.post('', { param: param }).then(datas => {
        if (datas.data) {
          event['id'] = datas.data[0];
          this.detail['chantier'] = event;
          this.isEdit = true; // pour permettre la sauvegarde quand on clique sur le bouton fermer
          // this.editChantier();
          // this.createCht = false;
          // this.chantier = {};
          this.closeCht();
        } else {
          this.isEdit = true;
          this.closeCht()
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
        }


      });
    } else {
      this.detail['client'].nomclass = 'Client';
      event.id = event.id || 0;
      const paramChantier = {
        'HOLDING_SERVLET': 'DBGestionProspect',
        'HOLDING_MODULE': 'Recylog',
        'HOLDING_TYPE': 'map',
        'HOLDING_COMPRESSION': 'false',
        'CHANTIER': event,
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 8
        },
        'CLIENT': this.detail['client'],
      };
      return this.common.DBGestionAppelHolding(paramChantier).then(datas => {
        const chantier = event;
        chantier.id = datas.data || 0;
        this.detail['chantier'] = chantier;
        this.closeCht();
      });
    }

  }

  changerZone(event) {
    this.detail['zone'] = event;
    this.isEdit = true;
    this.isEditChp['zone'] = false;
  }

  returnList() {
    this.hidefunction.emit();
    this.reloadbon.emit();
  }

  change(event) {
    this.etatBon = event.id;
    switch (event.id) {
      case 2:
        this.detail['pretAImprimer'] = false;
        this.detail['nePasImprimer'] = true;
        break;
      case 3:
        this.detail['pretAImprimer'] = true;
        this.detail['nePasImprimer'] = false;
        break;
      default:
        this.detail['pretAImprimer'] = false;
        this.detail['nePasImprimer'] = false;
        break;
    }
  }

  editChamp(val, event?) {
    if (event) {
      if ($(event.target).prop('tagName') !== 'INPUT' && $(event.target).prop('tagName') !== 'BUTTON' &&
        $(event.target).prop('tagName') !== 'I') {
        this.isEditChp = {};
        if (!this.detail['isImprimee'] && !this.detail['isReglee']) {
          if ($(event.target).prop('tagName') === 'A') {
            this.isEditChp[val] = false;
          } else {
            this.isEditChp[val] = this.isEditChp[val] ? false : true;
            setTimeout(function () {
              if ($('.' + val).length) {
                $('.' + val).focus();
                $('.selected').focus();
              } else {
                $('#' + val).focus();
              }
            }, 500);
          }
        }
      }
    } else {
      this.isEditChp[val] = this.isEditChp[val] ? false : true;
    }
  }

  focus(event) {
    /*
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
    */
  }

  searchSite(event) {
    this.result = [];
    this.listeSite.forEach(elt => {
      elt.libelleObjetEntite = elt.nom;
      this.result.push(elt);
    });
  }

  searchCommercial(event) {
    const listCom = this.common.getType('typeCom') || [];
    this.listUser = [];
    if (event !== '' && event !== 'Tous' && event !== 'tous') {
      listCom.forEach(elt => {
        elt.libelleObjetEntite = elt.libelle;
        const libelle = elt.libelleObjetEntite ? elt.libelleObjetEntite.toLowerCase() : '';
        event = ((event || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
        const lib = ((libelle || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
        if (lib.includes(event)) {
          this.listUser.push(elt);
        }
      });
    } else {
      listCom.forEach(elt => {
        elt.libelleObjetEntite = elt.libelle;
        this.listUser.push(elt);
      });
    }
  }

  showFiche() {
    this.ficheclient.emit();
  }

  getpays(id) {
    let elt;
    this.common.getType('typePays').forEach(elem => {
      if (elem.id === id) {
        elt = elem;
      }
    });
    return elt;
  }

  getDetail(objDevis, spinner?) {
    objDevis['nomclass'] = 'Devis';
    const param = {
      'servlet': 'DBGetDetailsDevis',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [
        {
          'typeParam': 'int',
          'valeur': objDevis.id
        },
        '' + this.common.user[2]
      ]
    };

    if (this.common.isProspectHolding) {

      const nombd = this.common.local.getObject('nomBDHolding') ? this.common.local.getObject('nomBDHolding').nomBDHolding : '';
      param['data'][2] = nombd || '';
    }

    return this.common.post('', { param: param }, spinner || false).then(datas => {
      this.devis['listLignes'] = datas.data[0] || [];
      this.devis['listLignes'].forEach(ligne => {
        ligne.accept = ligne.accept || false;
        ligne.dateDebut = (moment(ligne.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
        ligne.dateFin = (moment(ligne.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
        ligne.dateDebutModel = this.common.parseDate(moment(ligne.dateDebut, 'DD/MM/YYYY').format('DD/MM/YYYY'));
        ligne.dateFinModel = this.common.parseDate(moment(ligne.dateFin, 'DD/MM/YYYY').format('DD/MM/YYYY'));
        ligne.isTarifQte = ligne.isTarifQte || false;

        if (ligne.article) {
          ligne.article.isTarifQte = ligne.isTarifQte;
        }
      });
      if (!!this.devis['client'].codeClient) {
        const codeClient = this.devis['client'].codeClient;
        this.devis['client'] = datas.data[1];
        this.devis['client'].codeClient = codeClient;
      } else {
        this.devis['client'] = datas.data[1];
      }
      this.devis['formatParametrableSpecifiqueDefinit'] = datas.data[2];
      this.devis['lignesParSection'] = datas.data[3];
      if (datas.data.length > 4 && datas.data[4].id > 0) {
        this.devis['chantier'] = datas.data[4];
      }

      if (this.devis['dateCreation']) {
        this.devis['dateCreation'] = this.devis['dateCreation'].slice(0, 10);
        this.devis['dateCreationModel'] = this.common.parseDate(this.devis['dateCreation']);
      }

      if (this.devis['dateFinValidite']) {
        this.devis['dateFinValidite'] = this.devis['dateFinValidite'].slice(0, 10);
        this.devis['dateFinValiditeModel'] = this.common.parseDate(this.devis['dateFinValidite']);
      }

      if (this.devis['datePrevisionnelle']) {
        this.devis['datePrevisionnelle'] = moment(this.devis['datePrevisionnelle'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
        this.devis['datePrevisionnelleModel'] = this.common.parseDate(this.devis['datePrevisionnelle']);
        if (this.devis['datePrevisionnelle'] === '01/01/2020') {
          this.devis['datePrevisionnelle'] = '';
          this.devis['datePrevisionnelleModel'] = null;
        }
      }
      console.log('this.devis[\'dateAcceptation\'] : ' + this.devis['dateAcceptation']);
      if (this.devis['dateAcceptation']) {
        // this.devis['dateAcceptation'] = this.devis['dateAcceptation'].slice(0, 10);
        this.devis['dateAcceptation'] = moment(this.devis['dateAcceptation'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY')
        this.devis['dateAcceptationModel'] = this.common.parseDate(this.devis['dateAcceptation']);
        if (this.devis['dateAcceptation'] === '01/01/2020') {
          this.devis['dateAcceptation'] = '';
          this.devis['dateAcceptationModel'] = null;
        }
      }

      this.detail = this.devis;
      this.indexSection = 0;
      this.selectedSection = this.listSection && this.listSection[this.indexSection] ? this.listSection[this.indexSection] : { id: 0 };
      this.getLigneAffiche();
      if (this.detail['contact']) {
        this.getDetailContact(this.detail['contact'].id || 0);
      }
      datas.data[0].forEach((elt, index) => {
        elt.index = index;
      });
    }).catch(err => this.isClick = false);
  }

  getDetailContact(id) {
    if (this.detail['client']['prospectHolding']) {
      const nombd = this.common.local.getObject('nomBDHolding') ? this.common.local.getObject('nomBDHolding').nomBDHolding : '';
      this.client['nomclass'] = 'Client';
      const paramChantier = {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'HOLDING_SERVLET': 'DBGestionContact',
        'HOLDING_MODULE': 'Recylog',
        'HOLDING_TYPE': 'map',
        'HOLDING_COMPRESSION': 'true',
        'CLEF_CONTACT_CLIENT': {
          'typeParam': 'int',
          'valeur': id
        },
        'BD_HOLDING': nombd,
        'IS_PROSPECT_HOLDING': {
          'typeParam': 'boolean',
          'valeur': true
        },
      };
      return this.common.DBGestionAppelHolding(paramChantier).then(datas => {
        if (datas.data && datas.data !== null) {
          this.detail['contact'] = datas.data;
        }
      });
    } else {
      const param = {
        'servlet': 'DBGestionContact',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'true',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 4
          },
          'CLEF_CONTACT_CLIENT': {
            'typeParam': 'int',
            'valeur': id
          },
          'BD_HOLDING': '',
          'IS_PROSPECT_HOLDING': {
            'typeParam': 'boolean',
            'valeur': false
          }
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          this.detail['contact'] = datas.data;
        }
      });
    }

  }

  reloadContact(event) {
    if (!this.detail['client'].prospectHolding) {
      const param = {
        'servlet': 'DBGestionContact',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'true',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 4
          },
          'CLEF_CONTACT_CLIENT': {
            'typeParam': 'int',
            'valeur': event
          },
          'BD_HOLDING': '',
          'IS_PROSPECT_HOLDING': {
            'typeParam': 'boolean',
            'valeur': false
          }
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          this.detail['contact'] = datas.data;
        }
      });
    }


  }

  searchContact(event) {
    this.dataContact = [];
    if (!this.detail['client'].prospectHolding) {
      const param = 21;

      return this.common.appelComboK3Fct(param, event, [{
        nom: 'CLEF_CLIENT', valeur: {
          'typeParam': 'int',
          'valeur': (this.devis.client ? this.devis.client.id : this.client.id)
        }
      }]).then(datas => {
        // $('#autocomplete').trigger('click');
        if (datas.data) {
          this.dataContact = datas.data;
        } else {
          if (datas.message) {
            if (datas.message.includes('Utilisateur non authentifié')) {
              this.common.removeConnection();
            }
          }
        }
      });

    } else {
      const param = {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 7
        },
        'CLIENT': this.client,
        'HOLDING_SERVLET': 'DBGestionProspect',
        'HOLDING_MODULE': 'Recylog',
        'HOLDING_TYPE': 'map',
        'HOLDING_COMPRESSION': 'false',
        'CRITERE_CHANTIER': event || ''
      };
      return this.common.DBGestionAppelHolding(param).then(datas => {
        // $('#autocomplete').trigger('click');
        if (this.common.verifySession(datas)) {
          datas.data['listContact'] = datas.data['listContact'] || [];
          datas.data['listContact'].forEach(elt => elt.libelleObjetEntite = `${elt.prenom || ''} ${elt.nom || ''}`);
          this.dataContact = datas.data['listContact'] || [];
        }
      });
    }
  }

  getType(id) {
    let item;
    if (this.type) {
      this.type.filter(elt => {
        if (parseInt(elt.id, 10) === parseInt(id, 10)) {
          item = elt;
        }
      });
    }
    return item ? item.libelle : '';
  }

  getHeight() {
    if ($('.addLigne').height() === 54) {
      return 'calc(100% - 205px)';
    } else {
      const test = (205 + $('.addLigne').height()) - 54;
      return 'calc(100% - ' + test + 'px)';
    }
  }

  searchArticle(event, rowIndex) {
    console.log("searcArticle lhtr");
    this.dataArticle = [];
    const param = 2;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('.article' + (rowIndex || 0)).trigger('click');
      if (datas.data) {
        this.dataArticle = datas.data;
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  focus_toQte(index) {
    console.log('index', index)
    setTimeout(function () {
      $('#quantite' + index).focus();
    }, 600);
  }


  setValue(event, row?, rowIndex?, notfocus?) {
    this.isEdit = true;
    if (event && event.id && !this.isToogle && !this.isTooglePrestationEcoloc) {
      this.getDetailArticle(event.id, row).then(data => {
        row['article'] = data !== null ? data[0] : {};
        row.modifArticle = true;
        row.description = data !== null ? data[0].libelle : '';

        const argTypeClient = this.detail['client'].type ? this.detail['client'].type.id : 0;
        let argZoneChantier = (this.detail['chantier'] && this.detail['chantier'].zone) ? this.detail['chantier'].zone.id : 1;
        if (argZoneChantier === 0) {
          argZoneChantier = this.detail['zone'] ? this.detail['zone'].id : 1;
        }
        const argGrilleTarif = row['article'].grilleTarif ? row['article'].grilleTarif : false;
        row.tarif = data !== null ? data[0].tarif || this.getTarifClientZone(argTypeClient, argZoneChantier, argGrilleTarif)
          : this.getTarifClientZone(argTypeClient, argZoneChantier, argGrilleTarif); // data !== null ? data[0].tarif : '';
        row.txTVA = data !== null ? data[0].tva : '';
        row.typeTarif = data !== null ? data[0].typeTarif : '';
        this.calculMontant(row, true);
        if (!notfocus) {
          // $('.article' + (rowIndex || 0)).focus();
          setTimeout(function () {
            $('#quantite' + rowIndex).focus();
          }, 600);
        } else {
          $('#quantite' + rowIndex).click();
        }

      });
    }

  }

  actualiseArticleApres(row?, elemclick?) {
    const event = row.article || { id: 0 };
    if (event && event.id && !this.isToogle && !this.isTooglePrestationEcoloc) {
      this.getDetailArticle(event.id, row).then(data => {
        row['article'] = data !== null ? data[0] : {};
        row.modifArticle = true;
        row.description = data !== null ? data[0].libelle : '';

        const argTypeClient = this.detail['client'].type ? this.detail['client'].type.id : 0;
        let argZoneChantier = (this.detail['chantier'] && this.detail['chantier'].zone) ? this.detail['chantier'].zone.id : 1;
        if (argZoneChantier === 0) {
          argZoneChantier = this.detail['zone'] ? this.detail['zone'].id : 1;
        }
        const argGrilleTarif = row['article'].grilleTarif ? row['article'].grilleTarif : false;
        row.tarif = data !== null ? data[0].tarif || this.getTarifClientZone(argTypeClient, argZoneChantier, argGrilleTarif)
          : this.getTarifClientZone(argTypeClient, argZoneChantier, argGrilleTarif); // data !== null ? data[0].tarif : '';
        row.txTVA = data !== null ? data[0].tva : '';
        row.typeTarif = data !== null ? data[0].typeTarif : '';
        this.calculMontant(row, true)

        setTimeout(() => {
          $(elemclick).click();
        }, 150);


      });
    }
  }

  getDetailArticle(id, row) {
    const clef = '' + id;
    const clefZone = this.detail['zone'] && this.detail['zone'].id ? this.detail['zone'].id : 0;
    const clefSite = this.common.user[2];

    const param = {
      'servlet': 'DBGetArticle',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'forcerSerialisation': 'true',
      'data': ['DBGetArticle', clef, this.detail['client'] ? this.detail['client'].id : 0, this.detail['dateCreation'],
        this.detail['chantier'] ? this.detail['chantier'].id || 0 : 0, '' + (row.quantite || 0), '' + (row.contenant ? row.contenant.id || 0 : 0),
        '' + (row.articleContenantContenu ? row.articleContenantContenu.id || 0 : 0), '' + (row['exutoire'] ? row['exutoire'].id || 0 : 0),
        clefSite, '0', '0', clefZone]
      // 'data': ['DBGetArticle', clef, 0, '01/01/2000',
      //   0, 0, 0, 0, 0, this.common.user[2], '0']
    };
    return this.common.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }

  deleteLigne(row) {
    const temp = this.detail['listLignes'].filter(elt => elt !== row);
    this.changeDescription();
    this.detail['listLignes'] = temp;
    this.getLigneAffiche();
    this.modifDevis();
  }

  /*
  addLigneWithTimeout() {
    const ctrl = this;
    console.log('this.enableButtonAddLigne='+this.enableButtonAddLigne);

    if(this.enableButtonAddLigne) {
        this.enableButtonAddLigne = false;
        setTimeout(function () {
            ctrl.enableButtonAddLigne = true;
            ctrl.addLigne();
        }, 300);
    }
  }
  */

  addLigne() {
    let dateDeb;
    let dateF;
    // console.log('this.societe["datePNDefaut"]='+this.societe['datePNDefaut']);
    if (this.societe['datePNDefaut']) {
      dateDeb = this.common.parseDate(moment().startOf('year').format('MM/DD/YYYY'));
      dateF = this.common.parseDate('31/12/' + new Date().getFullYear());
    } else {
      dateDeb = this.common.parseDate(this.detail['dateCreation']);
      dateF = this.common.parseDate(this.detail['dateFinValidite']);
    }

    if (this.detail['listLignes'].length) {
      const firstLine = this.detail['listLignes'][0];
      if (!moment(firstLine.dateDebut).isSame(this.detail['dateCreation'])) {
        dateDeb = this.common.parseDate(firstLine.dateDebut);
      }
      if (!moment(firstLine.dateFin).isSame(this.detail['dateFinValidite'])) {
        dateF = this.common.parseDate(firstLine.dateFin);
      }
    }

    const ctrl = this;
    if (!this.detail['listLignes'] || (this.detail['listLignes'] && !this.detail['listLignes'].length)) {
      this.renderTable = false;
      setTimeout(function () {
        ctrl.renderTable = true;
      }, 100);
    }
    const objDevis = {
      id: -1 * (this.detail['listLignes'].length + 1),
      index: this.detail['listLignes'].length,
      idNouveauObjet: -1 * (this.detail['listLignes'].length + 1),
      dateDebut: moment(dateDeb).format('DD/MM/YYYY'),
      dateFin: moment(dateF).format('DD/MM/YYYY'),
      dateDebutModel: dateDeb,
      dateFinModel: dateF,
      accept: true
    }
    if (this.detail['lignesParSection']) {
      const section = this.listSection && this.listSection[this.indexSection] ? this.listSection[this.indexSection] : { id: 0 };
      objDevis['sectionDevis'] = {
        id: section.id
      };
    }
    this.detail['listLignes'].push(objDevis);
    this.detail['listLignes'] = [...this.detail['listLignes']];
    this.changeDescription();
    this.getLigneAffiche();
    let idx = this.detail['listLignes'].length - 1;


    this.selected = [];
    if (this.detail['listLignes'].length && this.detail['listLignes'][idx]) {
      this.selectRow(this.detail['listLignes'][idx]);
    }
    setTimeout(() => {
      // const elem = $('datatable-scroller:last-child')[0].lastElementChild;
      // elem.getElementsByClassName('detailfact')[0].focus();
      if (this.detail['lignesParSection']) {
        idx = this.selectedSection['ligneAffiche'].indexOf(objDevis);
      }
      $('.article' + (idx < 0 ? 0 : idx)).focus();
    }, 600);
  }

  updateDevis(detail, add?, close?, notReturnToList?) {
    if (detail['lignesParSection']) {
      detail['listLignes'] = [];
      this.listSection = this.listSection || [];
      this.listSection.forEach(elt => {
        detail['listLignes'] = [...detail['listLignes'], ...(elt['ligneAffiche'] || [])]
      });
    }
    console.log('Calling updateDevis()');
    console.log('detail[id]' + (detail['id'] ? detail['id'] : '0'));
    console.log('add=' + (add ? 'true' : 'false'));
    console.log('close=' + (close ? 'true' : 'false'));
    console.log('notReturnToList=' + (notReturnToList ? 'true' : 'false'));
    console.log('this.add=' + (this.add ? 'true' : 'false'));
    console.log(detail);
    detail['listLignes'] = detail['listLignes'] || [];
    detail['listLignes'].forEach(ligneDevis => {
      ligneDevis['accept'] = ligneDevis['accept'] || false;
    });
    this.positionnerDatesLignesDevis(detail);
    this.isClick = true;
    if (this.add) {
      detail['id'] = 0;
    }
    detail['nomclass'] = 'Devis';
    detail['datePrevisionnelle'] = detail['datePrevisionnelle'] &&
      detail['datePrevisionnelle'] !== '' ? detail['datePrevisionnelle'] : '01/01/2020';
    detail['dateAcceptation'] = detail['dateAcceptation'] && detail['dateAcceptation'] !== '' ? detail['dateAcceptation'] : '01/01/2020';

    const param = {
      'servlet': 'DBSaveDevis',
      'module': 'Ecocrm',
      'type': 'liste',
      'compression': 'false',
      'data': [
        detail,
        '' + this.common.user[2]
      ]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (!datas.message) {
        this.isClick = false;
        if (!close) {
          if (!add) {
            const listLignes = datas.data ? datas.data[1] : [];
            this.detail['listLignes'] = listLignes;
            this.common.createLog('45', this.detail['id'], false);
          } else {
            const id = datas.data ? datas.data[2] : 0;
            const numDevis = datas.data ? datas.data[0] : '';
            const listLignes = datas.data ? datas.data[1] : [];

            this.detail['id'] = id;
            this.detail['numDevis'] = numDevis;
            this.detail['listLignes'] = listLignes;
            this.common.createLog('45', id, true);
          }

          if (this.openId) {
            const id = datas.data ? datas.data[2] : 0;
            if (this.devis && this.devis['client'] && !!this.devis['client'].codeClient) {
              const codeClient = this.devis['client'].codeClient;
              this.devis = this.detail;
              this.devis['client'].codeClient = codeClient;
            } else {
              this.devis = this.detail;
            }
            this.detail['id'] = id;
            this.add = false;
          }

          if (!notReturnToList) {

            if (this.openId) {
              this.ngOnInit();
            } else {
              this.returnList();
            }
          }
        }
        return this.detail;
      } else {
        this.error = datas.message;
        this.isClick = false;
        this.common.openModal(this.modalService, this.msg);
      }
    }).catch(err => this.isClick = false);
  }

  positionnerDatesLignesDevis(detail) {
    const dateDevis = detail.dateCreation;
    const dateFinValidite = detail.dateFinValidite;

    this.detail['listLignes'].forEach((ligneDevis, index) => {
      if (ligneDevis.idNouveauObjet < 0) {
        ligneDevis.id = 0;
        ligneDevis.idNouveauObjet = 0;
      }
      // ligneDevis.dateDebut = dateDevis;
      // ligneDevis.dateFin = dateFinValidite;
      ligneDevis.description = ligneDevis.description || '';
      if (ligneDevis.article && !ligneDevis.article.id) {
        ligneDevis.description = ligneDevis.description || '';
        ligneDevis.article = {
          id: 0
        }
      }
    });
  }

  historiserDevis(detail) {
    detail['nomclass'] = 'Devis';
    this.isClick = true;
    return this.common.post('', {
      param: {
        'servlet': 'DBHistoDevis',
        'module': 'Ecocrm',
        'type': 'objet',
        'compression': 'false',
        'data': detail
      }
    }).then(datas => {
      this.isClick = false;
      this.common.closeModal();
      this.returnList();
    }).catch(error => this.isClick = false);
  }

  /**
   * ligneDevis change quelques fois quand on appele des services.
   * Ce méthode permet de restaurer les valeurs utiles choisies dans les dialogues.
   */
  restaurerValeursUserChoisi(listLigneDevisTmp) {
    this.detail['listLignes'].forEach((ligneDevis, index) => {
      listLigneDevisTmp.forEach(ligneDevisValeursUserChoisi => {
        if (index === ligneDevisValeursUserChoisi['index'] && ligneDevis['article'].id === ligneDevisValeursUserChoisi['article'].id) {
          if (ligneDevisValeursUserChoisi['creerPrixNegocie']) {
            ligneDevis['creerPrixNegocie'] = true;
          }

          if (ligneDevisValeursUserChoisi['validerCreerPrixNegocie']) {
            ligneDevis['validerCreerPrixNegocie'] = true;
          }

          if (ligneDevisValeursUserChoisi['createLibelleNegocie']) {
            ligneDevis['createLibelleNegocie'] = true;
          }
        }
      });
    });
  }

  // Pour permettre un seul click à la fois
  disabledAccepterBtnHandle() {
    console.log('Calling disabledAccepterBtnHandle() A');

    const ctrl = this;
    this.disabledAccepterBtn = true;
    setTimeout(function () {
      ctrl.disabledAccepterBtn = false;
      console.log('Calling disabledAccepterBtnHandle() B');
    }, 1000);
  }

  acceptationDevisFIP() {
    if (this.societe['gestionFIP']) {
      // après saveDevis et log
      this.updateDevis(this.detail, false, false, true).then(retourUpdateDevis => {
        this.isClick = true;
        this.getDetail(this.detail).then(() => {
          this.isClick = false;
          this.ouvertureFIPDND();
        }).catch(err => this.isClick = false);
      });

    } else {
      this.common.openModal(this.modalService, this.confirmeAccepteDevis);
    }
  }

  ouvertureFIPDND() {
    // A - Impression Format Parametrable de FIP DND
    $('#idImprimerCreation').prop('disabled', true);
    setTimeout(() => {
      $('#idImprimerCreation').prop('disabled', false);
    }, 700)
    const societe: any = this.societe;
    if (societe.gestionFIP) {
      const obj: any = this.detail || {};
      const devis = this.detail || {};
      this.common.getListFIP((obj.client ? obj.client.id : 0), false, true).then(listfipdnd => {
        console.log(listfipdnd)
        this.isFipDNDDejaImprimer(devis, listfipdnd).then(existe => {
          if (!existe && !societe.isFIPCET) {
            // imprimer FipDND
            this.isDD = false;
            this.ouvrirRenseignementsFIP(devis);
          } else {
            this.ouvertureFIPDD();
          }
        });
      });
    }
  }

  ouvertureFIPDD() {
    // B - Impression Format Parametrable de FIP DD
    const societe: any = this.societe;
    if (societe.gestionFIP) {
      const obj: any = this.detail || {};
      const devis = this.detail || {};
      this.common.getListFIP(obj.client ? obj.client.id : 0, true, true).then(listfipdd => {
        this.isFipDDDejaImprimer(devis, listfipdd).then(existeDD => {
          if (!existeDD && !this.societe['isFIPCET']) {
            // imprimer FipDD
            this.isDD = true;
            this.ouvrirRenseignementsFIPDD(devis);
          } else {
            this.common.openModal(this.modalService, this.confirmeAccepteDevis);
          }
        });
      });
    }
  }

  nextFIPClose() {
    if (!this.isDD) {
      this.ouvertureFIPDD()
    } else {
      this.common.openModal(this.modalService, this.confirmeAccepteDevis);
    }
  }

  validerDevis(detail) {
    console.log('Calling validerDevis()');

    // dateAcceptation
    detail['datePrevisionnelle'] = detail['datePrevisionnelle'] &&
      detail['datePrevisionnelle'] !== '' ? detail['datePrevisionnelle'] : '01/01/2020';
    detail['dateAcceptation'] = detail['dateAcceptation'] && detail['dateAcceptation'] !== '' ? detail['dateAcceptation'] : '01/01/2020';
    detail['nomclass'] = 'Devis';

    this.listLigneDevisTmp = this.common.clone(this.detail['listLignes']);

    this.updateDevis(this.detail, false, false, true).then(retourUpdateDevis => {
      if (!this.detail['client'].prospectHolding) {
        console.log('DBG VALIDER DEVIS A');
        this.valideArticleDepotDevis();
      } else {
        console.log('DBG VALIDER DEVIS B');
        this.isClick = true;
        this.getDetail(this.detail).then(() => {
          this.changeClientToProspect(this.detail['client']).then(() => {
            this.updateListContactChantier(this.detail['client']).then(() => {
              if (this.societe['codeClientAuto']) {
                this.validerProspect();
              } else {
                this.isClick = false;
                this.common.openModal(this.modalService, this.codeClientProspect);
              }
            }).catch(err => this.isClick = false);
          }).catch(err => this.isClick = false);
        }).catch(err => this.isClick = false);
      }
    });
  }

  serviceValidDevis() {
    console.log('Calling serviceValidDevis()');
    this.isClick = true;
    this.restaurerValeursUserChoisi(this.listLigneDevisTmp);
    this.detail['nomclass'] = 'Devis';
    this.detail['listLignes'].forEach((ligneDevis, index) => {
      ligneDevis['accept'] = ligneDevis['accept'] || false;
    });
    const param = {
      'servlet': 'DBValidDevis',
      'module': 'Ecocrm',
      'type': 'liste',
      'compression': 'false',
      'data': [
        this.detail,
        {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        {
          'typeParam': 'string',
          'valeur': this.common.getUrlPortail() || ''
        },
      ]
    };

    return this.common.post('', { param: param }).then(datas => {
      this.isClick = false;
      if (datas.message) {
        this.common.closeModal();
        this.error = datas.message;
        this.common.openModal(this.modalService, this.msg);
      } else {
        this.common.createLog('45', this.detail['id'], false);
        if (this.isVideFiltre) {
          this.common.filtreDevis = this.common.filtreDevis.filter(elt => elt.table !== 'prospectHolding');
          this.actualiseListe.emit();
        }
        this.returnList();
      }
    }).catch(err => this.isClick = false);
  }

  checkedAll(event) {
    this.listLibelleNegocier.forEach(elt => {
      elt.createLibelleNegocie = this.checkedall;
      this.checked(elt);
    });
  }

  checked(row) {
  }

  validerLibelleNego() {
    this.devis['listLignes'].forEach((ligneDevis, index) => {
      let createLibelleNegocie = false
      this.listLibelleNegocier.forEach(libelleNegocie => {
        if (libelleNegocie['index'] === ligneDevis['index'] && libelleNegocie['createLibelleNegocie']) {
          createLibelleNegocie = true;
        }
      });

      ligneDevis['createLibelleNegocie'] = createLibelleNegocie;
    });

    this.accepterDevis(null, 1);
  }

  annulerLibelleNego() {
    this.devis['listLignes'].forEach((ligneDevis, index) => {
      ligneDevis['createLibelleNegocie'] = false;
    });

    this.accepterDevis(null, 1);
  }

  changeClientToProspect(client) {
    client.nomclass = 'Client';
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 16
        },
        'CLIENT': client,
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        this.objProspect = datas.data;
        this.objProspect['id'] = client.id || 0;
        return datas.data;
      }
    });
  }

  updateListContactChantier(client) {
    client['nomclass'] = 'Client';
    const param = {
      'OPERATION': {
        'typeParam': 'int',
        'valeur': 7
      },
      'CLIENT': client,
      'HOLDING_SERVLET': 'DBGestionProspect',
      'HOLDING_MODULE': 'Recylog',
      'HOLDING_TYPE': 'map',
      'HOLDING_COMPRESSION': 'false',
      'CRITERE_CHANTIER': ''
    };
    return this.common.DBGestionAppelHolding(param).then(datas => {
      if (datas.data) {
        this.objProspect['listChantier'] = datas.data['listChantier'] || [];

        this.objProspect['listChantier'].forEach(elt => {
          if (elt.dateFin) {
            elt.dateFin = moment(elt.dateFin, 'YYYY-MM-DD').format('DD/MM/YYYY');
          }
        })
        this.objProspect['listContact'] = datas.data['listContact'] || [];
      }
    });
  }

  validerProspect() {
    this.objProspect['nomclass'] = 'Prospect';
    this.objProspect['listSociete'] = [];
    this.listeSociete.forEach(societe => {
      const soc = Object.assign({}, societe);
      soc['isUserVisible'] = true;
      this.objProspect['listSociete'].push(soc);
    });
    const param = {
      'PROSPECT': this.objProspect
    };
    this.isClick = true;
    this.common.DBGestionAppelHolding(param, 2).then(datas => {
      this.DBSetClientDevis(datas.data || 0)
    }).catch(err => this.isClick = false);
  }

  DBSetClientDevis(id) {
    const param = {
      'servlet': 'DBSetClientDevis',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'CLEF_PROSPECT': {
          'typeParam': 'int',
          'valeur': this.objProspect['id'] || 0
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data !== null) {
        this.isClick = true;
        this.getDetail(this.detail).then(dt => {
          this.listLigneDevisTmp = this.common.clone(this.detail['listLignes']);
          this.isVideFiltre = true;
          this.valideArticleDepotDevis(); // this.serviceValidDevis(this.listLigneDevisTmp, this.isVideFiltre);
        }).catch(err => this.isClick = false);
      }
    }).catch(err => this.isClick = false);
  }

  accepterDevis(detail, etape) {
    if (detail != null) {
      detail['dateAcceptation'] = moment().format('DD/MM/YYYY');
    }
    console.log('accepterDevis step ' + etape + ' called');
    this.accepteDevisMail = false;
    this.isEnvoiParEmail = false;
    this.LISTE_CLEF_MOUV = [];
    switch (etape) {
      case -1:
        if (this.devis['client'].prospect) {
          if (!this.common.local.getObject('paramSociete').codeClientAuto
            && !this.common.local.getObject('paramSociete').isGestionClientHolding) { // Vérifier si on doit saisir un code client
            this.common.openModal(this.modalService, this.dialogueCodeClient);
          } else {
            this.accepterDevis(detail, 0);
          }
        } else {
          this.accepterDevis(detail, 0);
        }
        break
      case 0: // Gestion libelle nego
        this.listLigneDevisTmp = [];
        this.isVideFiltre = false;

        console.log('Accepeer devis etape 1) check libelle nego');
        this.checkLibelleNegociesLignesDevis(this.detail).then(resCheckLibelleNego => {
          this.listLibelleNegocier = [];
          this.devis['listLignes'].forEach((ligneDevis, index) => {
            ligneDevis['index'] = index;
            ligneDevis['accept'] = ligneDevis['accept'] || false; // car accept est true par défaut dans le modèle

            if (ligneDevis.afficherLibelleNegocie) {
              let dejaDansLeTab = false;
              this.listLibelleNegocier.forEach(lModel => {
                dejaDansLeTab = lModel.description === ligneDevis.description;
              });

              if (!dejaDansLeTab && ligneDevis.article && ligneDevis.article.id > 0) {
                this.listLibelleNegocier.push(ligneDevis);
              }
            }
          });

          if (this.listLibelleNegocier.length > 0) {
            this.checkedAll(null);
            this.common.openModal(this.modalService, this.dialogueLibelleNego);
          } else {
            this.accepterDevis(null, 1);
          }
        });

        break;

      case 1:
        // Basculé après de la fin du traitement car il y avait un soucis de devis.clefClient et devis.clefChantier quand clients.isProspectHolding
        // Gestion de creation de prestation
        // console.log('Accepter devis etape 1) gestion création prestation');
        this.accepterDevis(null, 2); // Vers gestion prix nego
        break;

      case 2: // Gestion prix nego
        console.log('Accepter devis etape 2) gestion prix nego');
        const listLigneDevisTmp = this.common.clone(this.detail['listLignes']);
        this.checkParamPrixNegociesLignesDevis(this.detail).then(resCheckPrixNego => {
          console.log('Calling intérieur checkParamPrixNegociesLignesDevis');
          this.restaurerValeursUserChoisi(listLigneDevisTmp);
          this.devis['listLignes'].forEach((ligneDevis, index) => { // Vérifier s'il existe des prix négocier à demander
            ligneDevis['index'] = index;
            ligneDevis['accept'] = ligneDevis['accept'] || false; // car accept est true par défaut dans le modèle

            if (ligneDevis.validerCreerPrixNegocie && ligneDevis.tarif && ligneDevis.tarif !== 0) {
              this.listLignesTraiterPrixNego.push(ligneDevis);
            }
          });

          if (this.listLignesTraiterPrixNego.length > 0) { // Demander la création des prix négociés s'il y en a
            this.article_prix_nego = this.listLignesTraiterPrixNego[this.indexListLignes]['article'].code +
              '/' + this.listLignesTraiterPrixNego[this.indexListLignes]['article'].libelle;
            this.common.openModal(this.modalService, this.dialoguePrixNego);
            console.log('DBG ETAPE 2 A');
          } else {
            this.accepterDevis(null, 3); // étape 2 du mthd accepterDevis
            console.log('DBG ETAPE 2 B');
          }
        });

        break;

      case 3: // Gestion prix suite
        console.log('Accepter devis etape 3) gestion prix suite');
        this.listLignesTraiterPrixNego.forEach((elt, index) => { // Remettre les réponses des dialogues
          this.devis['listLignes'].forEach((elt2, index2) => {
            if (elt['id'] === elt2['id']) {
              elt2['creerPrixNegocie'] = elt['creerPrixNegocie'] || false;
            }
          });
        });

        this.listLignesTraiterPrixNego = [];
        this.indexListLignes = 0;

        const isDevisPNZero = this.common.local.getObject('paramSociete').isDevisPNZero;
        let devisPNZeroExist = false;
        if (isDevisPNZero) {
          this.devis['listLignes'].forEach((elt, index) => {
            if (elt.validerCreerPrixNegocie && (!elt.tarif || elt.tarif === 0)) {
              devisPNZeroExist = true;
            }
          });

          if (devisPNZeroExist) {
            this.common.openModal(this.modalService, this.dialoguePNZero);
          }
        }

        if (!devisPNZeroExist) { // Aucun dialogue PNZero n'est apparu
          this.accepterDevis(null, 4); // étape 4 du mthd accepterDevis
        }

        break;

      case 4: // Entre un code client, ou bien valide tout de suite le devis
        console.log('Accepter devis etape 4) code client ...');
        if (!this.devis['client'].prospectHolding) {
          GestionClient.getClient(this.devis['client'].id, true, this.common).then(datas => {
            if (datas.data && datas.data[0]) {
              if (!!this.devis['client'].codeClient) {
                const codeClient = this.devis['client'].codeClient;
                this.devis['client'] = datas.data[0];
                this.devis['client'].codeClient = codeClient;
              } else {
                this.devis['client'] = datas.data[0];
              }

              if (this.devis['client'].prospect) {
                // if (!this.common.local.getObject('paramSociete').codeClientAuto
                //   && !this.common.local.getObject('paramSociete').isGestionClientHolding) { // Vérifier si on doit saisir un code client
                //   this.common.openModal(this.modalService, this.dialogueCodeClient);
                // }
                console.log('DBG 4 A');
                this.accepterDevis(null, 5);
              } else { // Pas de saisie de code client
                console.log('DBG 4 B');
                this.validerDevis(this.devis);
              }
            } else { // Pas de saisie de code client
              console.log('DBG 4 C');
              this.validerDevis(this.devis);
            }

          });
        } else {
          console.log('DBG 4 D');
          this.validerDevis(this.devis);
        }


        break;

      case 5: // Bascule le tiers prospect en client
        console.log('Accepter devis etape 5) prospect => client');
        GestionClient.desactiverModeProspectClient(this.devis['client'], this.common).then(datas => {
          if (!datas.data || datas.data !== true) {
            this.common.closeModal();
            this.error = datas.message || 'Une erreur est survenue lors de la transormation du prospect en client';
            this.common.openModal(this.modalService, this.msg);
          } else {
            // Gestion de la visibilité du client 
            this.visibiliteValue = 1;
            if (this.devis['client'] && this.devis['client'].type && this.devis['client'].type.id === 1) {
              this.visibiliteValue = 2;
            }
            this.listModules.forEach(elt => elt.checked = false);
            this.common.openModal(this.modalService, this.visibilite);
          }
        });

        break;
    }
  }

  etapeSuivantApresDepot() {
    console.log('Calling etapeSuivantApresDepot()');
    if (this.societe['ecoloc']) {
      this.gestionCreationPrestationEcoloc();
    } else {
      this.etapeSuivantCreationPrestationEcoloc();
    }
  }

  //Gestion de creation de prestation ecoloc
  gestionCreationPrestationEcoloc() {
    let nbPrestation = 0;
    if (this.detail && this.detail['listLignes']) {
      this.detail['listLignes'].forEach(ligneDevis => {
        if (this.aUnArticlePrestationClient(ligneDevis)) {
          nbPrestation++;
        }
      });
    }

    switch (nbPrestation) {
      case 0: // pas de creation prestation ecoloc
        this.etapeSuivantCreationPrestationEcoloc();
        break;

      case 1: // creation prestation ecoloc avec 1 article
        this.valideArticlePrestationDevis();
        break;

      default: // > 1 creation prestation ecoloc avec x articles OU plusieurs prestations ecoloc
        this.common.closeModal();
        this.common.openModal(this.modalService, this.dialoguePrestationEcoloc);
        break;
    }
  }

  aUnArticlePrestationClient(ligneDevis) {
    if (ligneDevis.article && ligneDevis.article.familleArticle) {
      if ((ligneDevis.article.familleArticle.id && ligneDevis.article.familleArticle.id == 5) ||
        (ligneDevis.article.familleArticle.libelleObjetEntite && ligneDevis.article.familleArticle.libelleObjetEntite == 'Prestation Client')) {
        return true;
      }
    }

    return false;
  }

  repondreDialoguePrestationEcoloc(response) {
    this.common.closeModal();

    if (response) {
      this.valideArticlePrestationDevis();
    } else {
      this.valideArticlePrestationDevisXPrest();
    }
  }

  valideArticlePrestationDevis() {
    this.indexLigneDevisCreatePrestation = 0;
    this.whileListLigneDevisCreatePrestation(this.indexLigneDevisCreatePrestation);
  }

  /**
   * i : index du parcours de la liste ligne devis
   */
  whileListLigneDevisCreatePrestation(i) {
    console.log('whileListLigneDevisCreatePrestation(' + i + ') called');
    if (this.detail['listLignes'] && i < this.detail['listLignes'].length) {
      console.log('indexLigneDevisCreatePrestation=' + i);

      // initialisation objet planning
      this.planning = {
        client: this.detail['client'],
        showInfo: false,
        dateStart: this.common.parseDate(this.detail['dateCreation'].slice(0, 10))
      };
      if (this.detail['chantier'] && this.detail['chantier'].id) {
        this.planning['chantier'] = this.detail['chantier'];
      }

      const ligneDevis = this.detail['listLignes'][i];
      if (ligneDevis.accept && this.aUnArticlePrestationClient(ligneDevis)) {
        this.isTooglePrestationEcoloc = true;
        this.getDetailArticleById(ligneDevis['article'].id).then(data => {
          const article = data[0];
          this.planning['prestation'] = article;
          this.planning['prestation']['libelleObjetEntite'] = (article.code || '') + (article.code ? '/' : '') + (article.libelle);
        });
      } else {
        this.passerSurLaLigneSuivanteDuDevisPrestationEcoloc();
      }
    } else {
      this.etapeSuivantCreationPrestationEcoloc();
    }
  }

  getDetailArticleById(id) {
    const clef = '' + id;
    const param = {
      'servlet': 'DBGetArticle',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetArticle', clef]
    };
    return this.common.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }

  passerSurLaLigneSuivanteDuDevisPrestationEcoloc() {
    console.log('passerSurLaLigneSuivanteDuDevisPrestationEcoloc() called');
    this.indexLigneDevisCreatePrestation++;
    this.whileListLigneDevisCreatePrestation(this.indexLigneDevisCreatePrestation); // ligne suivante du devis
  }

  /**
   * Pour ouvrir une seule prestation LocMat avec plusieurs articles (XPrest)
   */
  valideArticlePrestationDevisXPrest() {
    console.log('valideArticlePrestationDevisXPrest() called');
    this.listArtPrest = [];
    if (this.detail['listLignes']) {
      this.detail['listLignes'].forEach(ligneDevis => {
        if (ligneDevis.accept && this.aUnArticlePrestationClient(ligneDevis)) {
          this.listArtPrest.push(ligneDevis['article']);
        }
      });
    }

    if (this.listArtPrest.length > 0) {
      // initialisation objet planning
      this.planning = {
        client: this.detail['client'],
        showInfo: false,
        dateStart: this.common.parseDate(this.detail['dateCreation'].slice(0, 10))
      };
      if (this.detail['chantier'] && this.detail['chantier'].id) {
        this.planning['chantier'] = this.detail['chantier'];
      }

      this.indexLigneDevisCreatePrestation = 0;
      this.listPrestation = [];
      this.createListArtPrest();
    }
  }

  createListArtPrest() {
    this.getDetailArticleById(this.listArtPrest[this.indexLigneDevisCreatePrestation].id).then(data => {
      const article = data[0];
      article['libelleObjetEntite'] = (article.code || '') + (article.code ? '/' : '') + (article.libelle);
      this.listPrestation.push({
        id: article['id'],
        article: article,
        qtePrevisionnelle: 0,
        libelle: article['libelle'],
        libelleObjetEntite: article['libelleObjetEntite']
      });

      if (this.indexLigneDevisCreatePrestation++ < this.listArtPrest.length - 1) {
        this.createListArtPrest();
      } else {
        this.planning['multiPrestation'] = true;
        this.planning['listPrestation'] = this.listPrestation;
        this.isTooglePrestationEcoloc = true;
      }
    });
  }

  etapeSuivantCreationPrestationEcoloc() {
    console.log('Calling etapeSuivantCreationPrestationEcoloc()');
    this.serviceValidDevis();
  }

  closeCreatePrestationDevis() {
    this.isTooglePrestationEcoloc = false;

    const crtl = this;
    setTimeout(function () {
      if (crtl.planning['multiPrestation']) {
        crtl.etapeSuivantCreationPrestationEcoloc();
      } else {
        crtl.passerSurLaLigneSuivanteDuDevisPrestationEcoloc();
      }
    }, 500);
  }

  actualiserCreatePrestationDevis() {
    console.log('Calling actualiserCreatePrestationDevis()');
  }

  reinitPrestationDevis() {
    console.log('Calling reinitPrestationDevis()');
  }

  /**
   * Gestion des articles de depots
   */
  valideArticleDepotDevis() {
    console.log('ACCEPTER DEVIS DBG 0');
    this.checkArticleDepotsDevis().then(datasCheckArticleDepotsDevis => {
      console.log('ACCEPTER DEVIS DBG 1');
      console.log(datasCheckArticleDepotsDevis);
      this.r_checkArticleDepotsDevis = datasCheckArticleDepotsDevis;
      // const d = datasCheckArticleDepotsDevis.data[0];
      // Le devis a t il un article de depot
      const devisHasArtDepot = datasCheckArticleDepotsDevis.data[1];
      // Des donnees sont elles presents dans la table benneChantiers
      const devisBenneChantier = datasCheckArticleDepotsDevis.data[2];

      console.log('devisHasArtDepot=' + devisHasArtDepot);
      console.log('devisBenneChantier=' + devisBenneChantier);
      const isCreationDepotDevis = (this.common.local.getObject('paramSociete') &&
        this.common.local.getObject('paramSociete').creationDepotDevis) || false;
      console.log('this.common.local.getObject(\'paramSociete\').creationDepotDevis=' + isCreationDepotDevis);

      if (devisHasArtDepot
        && ((!devisBenneChantier && !isCreationDepotDevis)
          || isCreationDepotDevis)) {
        console.log('ACCEPTER DEVIS DBG 2');
        let listClefMouv = [];
        this.indexLigneDevisCreateMvt = 0;
        this.indexNbBenneCreateMvt = 0;
        this.whileListLigneDevisCreateMvt(this.indexLigneDevisCreateMvt);
      } else {
        console.log('ACCEPTER DEVIS DBG 3');

        this.etapeSuivantApresDepot();
      }
      console.log('ACCEPTER DEVIS DBG 4');
    });
  }

  // Récupère le chantier de la ligneDevis, et s'il n'existe pas alors on récupère celui de devis
  getChantierLigneOuDevis(ligneDevis, devis) {
    const clefChantierLigneDevis = ligneDevis && ligneDevis.chantier && ligneDevis.chantier.id ? ligneDevis.chantier.id : 0;
    const clefChantierDevis = devis && devis.chantier && devis.chantier.id ? devis.chantier.id : 0;

    if (clefChantierLigneDevis) {
      return ligneDevis.chantier;
    } else if (clefChantierDevis) {
      return devis.chantier;
    } else {
      return false;
    }

  }

  /**
   * i : index du parcours de la liste ligne devis
   */
  whileListLigneDevisCreateMvt(i) {
    console.log('whileListLigneDevisCreateMvt(' + i + ') called');
    const d = this.r_checkArticleDepotsDevis.data[0];
    const lignesHasBenneChantier = this.r_checkArticleDepotsDevis.data[3];
    let creerDepot;
    let nePasVerifierDoublonContenant;
    let clefLigne;
    if (i < d.listLignes.length) {
      console.log('indexLigneDevisCreateMvt=' + i);
      const l = d.listLignes[i];
      console.log(l);

      creerDepot = true;
      nePasVerifierDoublonContenant = false;

      if (!l.accept) {
        console.log('continue car l.accept = false');
        this.passerSurLaLigneSuivanteDuDevis();
        return false;
      }

      // Article de depot ou de rotation
      if (l.article.famille === '2'
        || ((l.article.opBenne && l.article.opBenne.operationSupp)
          && !(l.article.opBenne && l.article.opBenne.operationSurBenneEnPlace))) {
        clefLigne = l.id;
        if (!this.common.local.getObject('paramSociete').creationDepotDevis && !(lignesHasBenneChantier[clefLigne] == false)
          && (!l.article.opBenne.operationSupp || l.article.opBenne.operationSurBenneEnPlace)) {
          console.log('ACCEPTER DEVIS DBG 5 CONTINUE');
          this.passerSurLaLigneSuivanteDuDevis();
          return false;
        }

        let nbBennes;
        this.getTypeContenantArticle(l.article.id).then(datasTypeContenantArticle => {
          console.log('ACCEPTER DEVIS DBG 6');
          console.log(l.article);

          const typeCont = datasTypeContenantArticle.data;
          console.log(typeCont);

          // Gestion de contenant deja present sur le chantier pour societe().isCreationDepotDevis = 1
          if (this.common.local.getObject('paramSociete').creationDepotDevis && (lignesHasBenneChantier[clefLigne] === true)) {
            console.log('Il existe déjà un contenant sur le chantier :');
            console.log(l.chantier ? l.chantier : 'Pas de chantier sur la ligne');
            this.passerSurLaLigneSuivanteDuDevis();
          } else if (creerDepot) {
            console.log('ACCEPTER DEVIS DBG 7');
            console.log(d);
            const chantier = this.getChantierLigneOuDevis(l, d);
            if (!chantier) { // On ne crée pas de prestation s'il n'y pas de chantier positionné
              // FenetreDevis.java 2278
              console.log('Il n\'y a pas de chantier positionné sur la ligne et sur le devis, on passe sur la ligne suivante');
              this.passerSurLaLigneSuivanteDuDevis();
            } else {
              // Apparition fenêtre création benne
              this.infoContenant['client'] = Object.assign({}, d.client);
              this.infoContenant['client'].libelleObjetEntite = this.infoContenant['client'].nomClient;
              this.infoContenant['chantier'] = Object.assign({}, chantier);
              this.infoContenant['contenant'] = Object.assign({}, typeCont);
              this.infoContenant['typeContenant'] = Object.assign({}, typeCont);
              this.infoContenant['quantite'] = 1;
              this.infoContenant['artDepot'] = Object.assign({}, l.article);
              this.infoContenant['devis'] = Object.assign({}, d);
              this.infoContenant['sitePrest'] = d['sitePrest'] ? Object.assign({}, d['sitePrest']) : { id: 0 };

              console.log(this.infoContenant);

              this.infoContenantCopy = Object.assign({}, this.infoContenant);

              console.log('typeCont.isUnitaire=' + typeCont.isUnitaire);
              if (typeCont.isUnitaire) {
                console.log('ACCEPTER DEVIS DBG 8');
                this.nbBennes = l.quantite;
                this.getNbBennesADeposer();
              } else {
                console.log('ACCEPTER DEVIS DBG 9');
                this.nbBennes = 1;
                this.infoContenant['quantite'] = l.quantite;
                this.showPanelCreateMvt();
              }
            }
          }
        });
      } else {
        console.log('ACCEPTER DEVIS DBG 10');
        this.passerSurLaLigneSuivanteDuDevis();
        /*
        this.indexLigneDevisCreateMvt++;
        this.whileListLigneDevisCreateMvt(this.indexLigneDevisCreateMvt); // ligne suivante du devis
        */
      }
    } else {
      console.log('ACCEPTER DEVIS DBG 11 Les créations sont terminées ___ this.LISTE_CLEF_MOUV = ' + this.LISTE_CLEF_MOUV.length);
      if (this.LISTE_CLEF_MOUV && this.LISTE_CLEF_MOUV.length) {
        this.common.openModal(this.modalService, this.CRMail);
      } else {
        this.etapeSuivantApresDepot();
      }
    }
  }

  ouiMail() {
    this.accepteDevisMail = true;
    const param = {
      'servlet': 'DBGestionFormatParametrable',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLEF_TYPE_FORMAT': {
          'typeParam': 'int',
          'valeur': 36
        },
        'LES_DEUX_LISTES': {
          'typeParam': 'boolean',
          'valeur': false
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.formatPerso = datas.data;
      if (this.formatPerso.length > 1) {
        this.formatprs = this.formatPerso[0];
        // open modal
        this.common.openModal(this.modalService, this.format);
      } else {
        // get pdf to print
        if (this.formatPerso.length === 1) {
          this.formatprs = this.formatPerso[0];
          this.envoyerParEmail();
        } else {
          this.common.openModal(this.modalService, this.format);
        }
      }
    });
  }

  nonMail() {
    this.etapeSuivantApresDepot();
  }


  showPanelCreateMvt() {
    console.log('showPanelCreateMvt() called');
    this.common.closeModal();
    // this.toogleSlide();
    this.isToogle = true;
    // this.common.openModal(this.modalService, this.testCreationMouvement);
  }

  /**
   * index nombre de benne à poser
   */
  whileNbBenneCreateMvt(j) {
    console.log('whileNbBenneCreateMvt(' + j + ') called');
    if (j < this.nbBennes) {
      console.log('ACCEPTER DEVIS DBG 12');
      // this.whileListLigneDevisCreateMvt(this.indexLigneDevisCreateMvt);
      this.infoContenant = Object.assign({}, this.infoContenantCopy);
      console.log(this.infoContenant);
      this.showPanelCreateMvt();
    } else {
      console.log('ACCEPTER DEVIS DBG 13');
      this.common.closeModal();
      this.passerSurLaLigneSuivanteDuDevis();
    }
  }

  getNbBennesADeposer() {
    console.log('getNbBennesADeposer() called; indexLigneDevisCreateMvt=' + this.indexLigneDevisCreateMvt);
    console.log(this.r_checkArticleDepotsDevis);
    if (this.r_checkArticleDepotsDevis && this.r_checkArticleDepotsDevis.data[0].listLignes &&
      this.r_checkArticleDepotsDevis.data[0].listLignes[this.indexLigneDevisCreateMvt]
      && this.r_checkArticleDepotsDevis.data[0].listLignes[this.indexLigneDevisCreateMvt].description) {
      this.descriptionDialogueNbBenne = this.r_checkArticleDepotsDevis.data[0].listLignes[this.indexLigneDevisCreateMvt].description;
    } else {
      this.descriptionDialogueNbBenne = '';
    }

    this.common.closeModal();
    this.common.openModal(this.modalService, this.dialogueNbBenne);
  }

  passerSurLaLigneSuivanteDuDevis() {
    console.log('passerSurLaLigneSuivanteDuDevis() called');
    this.indexNbBenneCreateMvt = 0;
    this.nbBennes = 0;
    this.indexLigneDevisCreateMvt++;
    this.whileListLigneDevisCreateMvt(this.indexLigneDevisCreateMvt); // ligne suivante du devis
  }

  handleBtnTerminerCreationMvt(event?) {
    console.log('handleBtnTerminerCreationMvt() called');
    if (event) {
      this.LISTE_CLEF_MOUV = [...this.LISTE_CLEF_MOUV, ...event];
    }
    this.indexNbBenneCreateMvt++;
    this.whileNbBenneCreateMvt(this.indexNbBenneCreateMvt); // benne suivant de la même ligne devis
  }

  checkArticleDepotsDevis() {
    console.log('checkArticleDepotsDevis() called');

    this.detail['nomclass'] = 'Devis';
    const param = {
      'servlet': 'DBCheckArtDepotDevis',
      'module': 'Ecocrm',
      'type': 'liste',
      'compression': 'false',
      'data': [
        this.detail,
        {
          'typeParam': 'int',
          'valeur': parseInt(this.common.user[2], 10)
        },
      ]
    };

    return this.common.post('', { param: param }, true);
  }

  getTypeContenantArticle(clefArticle) {
    const param = {
      'servlet': 'DBGestionChargeJourBenne',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_ARTICLE': {
          'typeParam': 'int',
          'valeur': clefArticle
        },
      }
    };

    return this.common.post('', { param: param });
  }

  validerVisibilite() {
    this.detail['client']['visibilite'] = this.detail['client']['visibilite'] || {};
    this.detail['client']['visibilite'].id = this.visibiliteValue;
    this.detail['client']['listModule'] = this.listModules.filter(elt => elt.checked === true);
    this.saveVisibilite();
    this.validerDevis(this.devis);
  }

  saveVisibilite() {
    this.detail['client']['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBMAJVisibilite',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'ACTUALISER_CLEF_VISIBILITE': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'CLIENT': this.detail['client']
      }
    };

    return this.common.post('', { param: param });
  }

  repondreCodeClient() {
    console.log("this.devis['client'].codeClient : " + this.devis['client'].codeClient);
    if (this.devis['client'].codeClient
      && this.devis['client'].codeClient !== '') {
      this.common.closeModal();
      this.accepterDevis(this.detail, 0); // bascule le tiers prospect en client
    } else {
      // l'utilisateur n'a pas saisi un code client
      console.log('L\'utilisateur n\'a pas saisi un code client');
    }
  }

  repondreDialoguePNZero(response) {
    this.common.closeModal();
    if (response) {
      this.devis['listLignes'].forEach((elt, index) => {
        if (elt.validerCreerPrixNegocie && (!elt.tarif || elt.tarif === 0)) {
          elt.creerPrixNegocie = true;
        }
      });
    }

    this.accepterDevis(null, 4); // étape 3 du mthd accepterDevis
  }

  repondreDialoguePrixNego(response) {
    this.common.closeModal();

    if (this.indexListLignes < this.listLignesTraiterPrixNego.length - 1) {
      this.listLignesTraiterPrixNego[this.indexListLignes].creerPrixNegocie = response;
      this.indexListLignes = this.indexListLignes + 1;
      this.article_prix_nego = this.listLignesTraiterPrixNego[this.indexListLignes]['article'].code +
        '/' + this.listLignesTraiterPrixNego[this.indexListLignes]['article'].libelle;
      this.common.openModal(this.modalService, this.dialoguePrixNego);
    } else {
      this.listLignesTraiterPrixNego[this.indexListLignes].creerPrixNegocie = response;
      this.accepterDevis(null, 3); // étape 3 du mthd accepterDevis
    }
  }

  checkParamPrixNegociesLignesDevis(objDevis) {
    console.log('Calling checkParamPrixNegociesLignesDevis()');

    objDevis['nomclass'] = 'Devis';
    const param = {
      'servlet': 'DBCheckParamPrixNegocie',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'data': {
        'DEVIS': objDevis
      }
    };

    return this.common.post('', { param: param }, true).then(datas => {
      if (datas.data && datas.data['listLignes']) {
        this.detail = datas.data;
        if (!!this.devis['client'].codeClient) {
          const codeClient = this.devis['client'].codeClient;
          this.devis = this.detail;
          this.devis['client'].codeClient = codeClient;
        } else this.devis = this.detail;
      } else {
        if (datas.message) {
          this.common.closeModal();
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }
    });
  }

  checkLibelleNegociesLignesDevis(objDevis) {
    objDevis['nomclass'] = 'Devis';
    const param = {
      'servlet': 'DBCheckLibelleNegocie',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'data': {
        'DEVIS': objDevis
      }
    };

    return this.common.post('', { param: param }, true).then(datas => {
      if (datas.data && datas.data['listLignes']) {
        this.detail = datas.data;
        if (!!this.devis['client'].codeClient) {
          const codeClient = this.devis['client'].codeClient;
          this.devis = this.detail;
          this.devis['client'].codeClient = codeClient;
        } else this.devis = this.detail;
      } else {
        if (datas.message) {
          this.common.closeModal();
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }
    });
  }

  getTarif(row) {
    const article = row['article'] || {};
    article['grilleTarif'] = article['grilleTarif'] || { id: 0 };
    article['grilleTarif'].nomclass = 'TarifArticle';
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 18
        },
        'TARIF_ARTICLE': article['grilleTarif'],
        'TYPE_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['client'] && this.detail['client'].type ? (this.detail['client'].type.id || 0) : 0
        },
        'CLEF_ZONE': {
          'typeParam': 'int',
          'valeur': row['chantier'] && row['chantier'].zone && row['chantier'].zone.id
            ? row['chantier'].zone.id : 1
        },
      }
    };
    return this.common.post('', { param: param });
  }

  modifDevis() {
    this.detail['nomclass'] = 'Devis';

    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'DEVIS': this.detail
      }
    };

    const detailAvant = Object.assign({}, this.detail);
    return this.common.post('', { param: param }).then(datas => {
      if (datas.data && datas.data.listLignes) {
        this.dataModel2 = datas.data.listLignes;
        const listLigne = detailAvant['listLignes'] || [];
        datas.data.listLignes = detailAvant['listLignes'] || [];
        datas.data.listLignes.forEach((elt, index) => {
          elt.quantite = parseFloat((elt.quantite || '0'));
          elt.quantiteAnnuelle = parseFloat((elt.quantiteAnnuelle || '0'));
          elt.tarif = parseFloat((elt.tarif || '0'));
          elt.index = index;
          elt.accept = elt.accept || false;
          const objAvant = listLigne[index] || {};
          elt.showQteInput = objAvant.showQteInput || false;
          elt.showPUInput = objAvant.showPUInput || false;
          this.calculMontant(elt);
          elt.isTarifQte = elt.isTarifQte || false;

          if (elt.article) {
            elt.article.isTarifQte = elt.isTarifQte;
          }
          // const oMomentDateDebut = moment(elt.dateDebut, 'DD/MM/YYYY HH:mm:ss');
          // const oMomentDateFin = moment(elt.dateFin, 'DD/MM/YYYY HH:mm:ss');
          // elt.dateDebutModel = this.common.parseDate(moment(elt.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
          // elt.dateFinModel = this.common.parseDate(moment(elt.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
        });
        this.listeSite.forEach(elt => {
          elt.libelleObjetEntite = elt.nom;
          if (datas.data.sitePrest && elt.id === datas.data.sitePrest.id) {
            datas.data.sitePrest = elt;
          }

          if (datas.data.siteCA && elt.id === datas.data.siteCA.id) {
            datas.data.siteCA = elt;
          }
        });

        datas.data.dateCreation = datas.data.dateCreation ? datas.data.dateCreation.slice(0, -9) : this.detail['dateCreation'];
        datas.data.dateFinValidite = datas.data.dateFinValidite ? datas.data.dateFinValidite.slice(0, -9) : this.detail['dateFinValidite'];
        if (datas.data.dateCreation) {
          datas.data['dateCreationModel'] = this.common.parseDate(datas.data['dateCreation']);
        }

        if (datas.data['dateFinValidite']) {

          datas.data['dateFinValiditeModel'] = this.common.parseDate(datas.data['dateFinValidite']);
        }

        this.detail = datas.data;
        if (this.detail['datePrevisionnelle']) {
          this.detail['datePrevisionnelle'] = moment(this.detail['datePrevisionnelle'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
          this.detail['datePrevisionnelleModel'] = this.common.parseDate(this.detail['datePrevisionnelle']);
          if (this.detail['datePrevisionnelle'] === '01/01/2020') {
            this.detail['datePrevisionnelle'] = '';
            this.detail['datePrevisionnelleModel'] = null;
          }
          console.log(this.detail['datePrevisionnelleModel'])
        }

        if (this.detail['dateAcceptation']) {
          // this.detail['dateAcceptation'] = this.detail['dateAcceptation'].slice(0, 10);
          this.detail['dateAcceptation'] = moment(this.detail['dateAcceptation'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY')
          this.detail['dateAcceptationModel'] = this.common.parseDate(this.detail['dateAcceptation']);
          if (this.detail['dateAcceptation'] === '01/01/2020') {
            this.detail['dateAcceptation'] = '';
            this.detail['dateAcceptationModel'] = null;
          }
          console.log(this.detail['dateAcceptationModel'])
        }

        if (this.detail['contact']) {
          this.getDetailContact(this.detail['contact'].id || 0);
        }
      }
    });
  }

  calculMontantAvecRem(row, notActualise?) {
    this.isEdit = true;
    if (row.quantite && row.tarif) {
      if (!row.pourcentageRemise) {
        row.montantHT = row.quantite * row.tarif;
      } else {
        row.montantHT = (row.quantite * row.tarif) * (1 - row.pourcentageRemise / 100);
      }
    } else {
      row.montantHT = 0;
    }
    if (!notActualise) {
      this.getPrix();
    }

  }

  calculMontant(row, isActualiseArtCont?) {
    this.isEdit = true;
    if (row.quantite && row.tarif) {
      row.montantHT = row.quantite * row.tarif;
    } else {
      row.montantHT = 0;
    }
    const isdepuisArtContenu = isActualiseArtCont ? false : true;
    this.calculMontantAvecRem(row, isdepuisArtContenu);
    // this.getPrix();
  }

  getPrix(val?) {
    clearTimeout(this.timeout);
    this.isEdit = val ? false : true;
    const ctrl = this;

    // this.timeout = setTimeout(function () {
    ctrl.modifDevis();
    // }, 1000);
  }

  changeDescription() {
    this.isEdit = true;
  }

  montantapayer() {
    return parseFloat(this.detail['montantTTC'] || 0) - parseFloat(this.detail['montantRegle'] || 0);
  }

  toFixed(val) {
    return parseFloat(val).toFixed(this.nbdigit);
  }

  getFormatperso(typeImp?) {
    this.common.closeModal();
    this.typeImp = typeImp || false;

    const param = {
      'servlet': 'DBGestionFormatParametrable',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLEF_TYPE_FORMAT': {
          'typeParam': 'int',
          'valeur': 1
        },
        'LES_DEUX_LISTES': {
          'typeParam': 'boolean',
          'valeur': false
        }
      }
    };
    this.formatPerso = [];
    this.common.post('', { param: param }).then(datas => {
      this.formatPerso = datas.data;
      if (this.formatPerso.length > 1) {
        this.formatprs = this.formatPerso[0];
        // open modal
        this.common.openModal(this.modalService, this.format);
      } else {
        // get pdf to print
        if (this.formatPerso.length === 1) {
          this.formatprs = this.formatPerso[0];
          if (this.isEnvoiParEmail) {
            this.isEnvoiParEmail = false;
            this.add ? this.envoyerParEmailAdd() : this.envoyerParEmail();
          } else {
            this.add ? this.printAdd() : this.print();
          }
        } else {
          this.common.openModal(this.modalService, this.format);
        }
      }
    });
  }

  searchChantier(event) {
    if (!this.detail['client'].prospectHolding) {
      const param = {
        'servlet': 'DBGetChantierClient',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {

          'SITE': {
            'typeParam': 'int',
            'valeur': this.common.user[2]
          },
          'CLEF_CLIENT': {
            'typeParam': 'int',
            'valeur': this.detail['client'].id
          },
          'CRITERE': event || ''
        }
      };
      const societe = this.common.local.getObject('paramSociete') || {};
      if (societe['visuChantierDateFin']) {
        param['data']['NBR_MOIS_VISU_CHANTIER'] = {
          'typeParam': 'int',
          'valeur': societe['nbrMoisVisuChantier'] || 0
        }
      }

      return this.common.post('', { param: param }).then(datas => {
        // $('.chantier').trigger('click');
        if (this.common.verifySession(datas)) {
          this.listChantier = [...[{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }], ...(datas.data || [])];
        }
      });
    } else {
      const param = {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 7
        },
        'CLIENT': this.client,
        'HOLDING_SERVLET': 'DBGestionProspect',
        'HOLDING_MODULE': 'Recylog',
        'HOLDING_TYPE': 'map',
        'HOLDING_COMPRESSION': 'false',
        'CRITERE_CHANTIER': event || ''
      };
      return this.common.DBGestionAppelHolding(param).then(datas => {
        // $('.chantier').trigger('click');
        if (this.common.verifySession(datas)) {
          this.listChantier = [...[{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }], ...(datas.data['listChantier'] || [])];
          this.listChantier.forEach(elt => {
            if (elt.dateFin) {
              elt.dateFin = moment(elt.dateFin, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
          });
        }
      });
    }

  }

  print() {
    console.log('Calling print()');
    if (!this.formatprs || (this.formatprs && !this.formatprs['id'])) {
      this.error = 'Vous devez sélectionner un format paramétrable.';
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    // Enregistre le devis avant impression s'il peut être modifié (Btn Enregistrer visible)
    if (!this.isDepuisFacturation && !this.detail['isHisto'] && this.isDroitModifDevis) {
      const isAdd = this.detail['id'] == 0;
      this.updateDevis(this.detail, isAdd, true).then(retourSave => {
        this.callPrintServlet();
      });
    } else {
      this.callPrintServlet();
    }
  }

  callPrintServlet() {
    this.detail['nomclass'] = 'Devis';
    if (this.detail['listLignes']) {
      this.detail['listLignes'].forEach(ligne => {
        if (!ligne['description']) {
          ligne['description'] = '';
        }
      });
    }

    const param = {
      'servlet': 'DBImprimeDevis',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Ecocrm/tmp/Devis/',
      'data': {
        'CLEF_USER': {
          // 'id': 1,
          // 'nomclass': 'Bon'
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'DEVIS': this.detail,
        'FORMAT': '',
        'CLEF_FORMAT_PARAMETRABLE': {
          'typeParam': 'int',
          'valeur': '' + this.formatprs['id']
        },
        'IS_VISUALISATION': {
          'typeParam': 'boolean',
          'valeur': 'false'
        }
      }
    };

    if (this.common.isProspectHolding) {
      const nombd = this.common.local.getObject('nomBDHolding') ? this.common.local.getObject('nomBDHolding').nomBDHolding : '';
      param['data']['BD_HOLDING'] = nombd;
    }

    this.common.post('', { param: param }, true).then(datas => {
      if (datas.data && datas.data.length) {
        this.common.openFile(datas.data[0]);
        // this.common.closeModal();
        this.formatprs = '';
        // gestion FIP
        this.gestionFIPDND();
      } else {
        if (datas.message) {
          // this.common.closeModal();
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }
    });
  }

  createDevis(close?, returnToList?) {
    console.log('Calling createDevis()');
    this.detail['nomclass'] = 'Facture';

    this.detail['id'] = 0;
    this.isClick = true;
    return this.updateDevis(this.detail, true, close ? false : true, (returnToList ? false : close));
  }

  printAdd() {
    console.log('Calling printAdd()');
    if (!this.formatprs || (this.formatprs && !this.formatprs['id'])) {
      this.error = 'Vous devez sélectionner un format paramétrable.';
      this.common.openModal(this.modalService, this.msg);
      return;
    }
    this.createDevis(true).then(data => {
      this.add = false;
      this.print();
    });
  }

  getListeSite() {
    const info = this.common.local.getObject('userDetail');
    this.common.post('', {
      param: {
        'servlet': 'DBGetListSiteUser',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'NOM_UTILISATEUR': info.login,
          'IS_HOLDING': {
            'typeParam': 'boolean',
            'valeur': '0'
          }
        }
      }
    }).then(datas => {
      this.common.local.setObject('listeSite', datas.data[0]);
      this.listeSite = datas.data[0];
    }).catch(error => console.log(error));
  }

  getListeAffaire() {
    this.common.post('', {
      param: {
        'servlet': 'DBGestionAffaire',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'true',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': '2'
          },
          'CLEF_CLIENT': {
            'typeParam': 'int',
            'valeur': (this.devis.client ? this.devis.client.id : this.client.id)
          },
          'CLEF_SITE': {
            'typeParam': 'int',
            'valeur': this.common.user[2]
          },
          'CLEF_USER': {
            'typeParam': 'int',
            'valeur': this.common.user[0]
          },
          'AFFICHER_POURCENTAGE': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_TERMINE': {
            'typeParam': 'boolean',
            'valeur': false
          }
        }
      }
    }).then(datas => {
      this.listeAffaire = datas.data;
    }).catch(error => console.log(error));
  }

  getListeZone() {
    this.common.post('', {
      param: {
        'servlet': 'DBGetListZone',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {}
      }
    }).then(datas => {
      const zone_libelle = datas.data[0];
      const zone_id = datas.data[1];
      this.listeZone = [{ id: 0, libelle: 'Toutes', libelleObjetEntite: 'Toutes' }];

      zone_id.forEach((elt, index) => {
        this.listeZone.push({
          id: elt,
          libelle: zone_libelle[index],
          libelleObjetEntite: zone_libelle[index],
        });
      });

    }).catch(error => console.log(error));
  }

  inserteLigne() {
    let dateDeb;
    let dateF;
    // console.log('this.societe["datePNDefaut"]='+this.societe['datePNDefaut']);
    if (this.societe['datePNDefaut']) {
      dateDeb = this.common.parseDate(moment().startOf('year').format('MM/DD/YYYY'));
      dateF = this.common.parseDate('31/12/' + new Date().getFullYear());
    } else {
      dateDeb = this.common.parseDate(this.detail['dateCreation']);
      dateF = this.common.parseDate(this.detail['dateFinValidite']);
    }

    if (this.detail['listLignes'].length) {
      const firstLine = this.detail['listLignes'][0];
      if (!moment(firstLine.dateDebut).isSame(this.detail['dateCreation'])) {
        dateDeb = this.common.parseDate(firstLine.dateDebut);
      }
      if (!moment(firstLine.dateFin).isSame(this.detail['dateFinValidite'])) {
        dateF = this.common.parseDate(firstLine.dateFin);
      }
    }

    const ctrl = this;
    if (!this.detail['listLignes'] || (this.detail['listLignes'] && !this.detail['listLignes'].length)) {
      this.renderTable = false;
      setTimeout(function () {
        ctrl.renderTable = true;
      }, 100);
    }

    const objDevis = {
      id: (-1 * (this.detail['listLignes'].length + 1)), idNouveauObjet: (-1 * (this.detail['listLignes'].length + 1)),
      dateDebut: moment(dateDeb).format('DD/MM/YYYY'),
      dateFin: moment(dateF).format('DD/MM/YYYY'),
      dateDebutModel: dateDeb,
      dateFinModel: dateF,
      accept: true
    }
    if (this.detail['lignesParSection']) {
      const section = this.listSection && this.listSection[this.indexSection] ? this.listSection[this.indexSection] : { id: 0 };
      objDevis['sectionDevis'] = {
        id: section.id
      };
    }
    this.detail['listLignes'].splice(this.focusIndex, 0, objDevis);
    this.detail['listLignes'] = [...this.detail['listLignes']];
    this.selected = [];
    if (this.detail['listLignes'].length && this.detail['listLignes'][this.focusIndex]) {
      this.selectRow(this.detail['listLignes'][this.focusIndex]);
    }
    this.getLigneAffiche();
    this.changeDescription();

    setTimeout(() => {
      if (this.detail['lignesParSection']) {
        const idx = this.selectedSection['ligneAffiche'].indexOf(objDevis);
        $('.article' + (idx)).focus();
      } else {
        $('.article' + (ctrl.focusIndex)).focus();
      }
    }, 600);
  }

  setIndex(row) {
    this.focusIndex = this.detail['listLignes'].indexOf(row);
  }

  onDrag(event) {
    this.selected = [event];
    console.log('this.selected', this.selected);
    event.dragstart = true;
    this.idFocus = event.id;
    this.selected.forEach(elt => elt.dragstart = true);
  }

  onDrop(event) {
    const newData = event.slice();
    this.isEdit = true;
    newData.forEach(el => {
      el.dragstart = false;
      el.dateDebutModel = this.common.parseDate(moment(el.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
      el.dateFinModel = this.common.parseDate(moment(el.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
    });
    this.selected = [];
    this.focusIndex = 0;

    this.renderTable = false;
    if (!this.detail['lignesParSection']) {
      this.detail['listLignes'] = [];
    } else {
      this.selectedSection['ligneAffiche'] = [];
    }

    setTimeout(() => {
      if (!this.detail['lignesParSection']) {
        this.detail['listLignes'] = [...newData];
        this.detail['listLignes'].forEach((element, idx) => {
          if (element.id === this.idFocus) {
            this.focusIndex = idx;
          }
        });
      } else {
        this.selectedSection['ligneAffiche'] = [...newData];
        this.selectedSection['ligneAffiche'].forEach((element, idx) => {
          if (element.id === this.idFocus) {
            this.focusIndex = idx;
          }
        });

        this.detail['listLignes'] = [];
        this.listSection = this.listSection || [];
        this.listSection.forEach(elt => {
          this.detail['listLignes'] = [...this.detail['listLignes'], ...(elt['ligneAffiche'] || [])]
        });
      }


      this.renderTable = true;
      setTimeout(() => {
        $('datatable-body').scrollTop(this.focusIndex * 30);
      }, 10);
    }, 0);
  }

  selectRow(row, notPushSelected?) {
    // console.log('Calling selectRow');
    if (!this.detail['lignesParSection']) {
      this.focusIndex = this.detail['listLignes'].indexOf(row);
    } else {
      this.focusIndex = this.selectedSection['ligneAffiche'].indexOf(row);
    }

    const doPushSelected = !(notPushSelected ? true : false);
    if (doPushSelected) {
      this.selected.push(row);
    }
    this.idFocus = row.id;
  }

  ouvrirDialogueDupliquer() {
    this.common.filtreDevisDupliquerClient = [];
    this.common.openModal(this.modalService, this.dialogueDupliquer);
  }

  ouvrirDialogueRefuser() {
    this.listeMotifRefusDevis = this.common.local.getObject('ecocrm').listeMotifRefusDevis;
    this.common.openModal(this.modalService, this.dialogueDmdMotifRefus);
  }

  getDetailProspect(id) {
    const param = {
      'OPERATION': {
        'typeParam': 'int',
        'valeur': 1
      },
      'CLEF_PROSPECT': {
        'typeParam': 'int',
        'valeur': id || 0
      },
      'HOLDING_SERVLET': 'DBGestionProspect',
      'HOLDING_MODULE': 'Recylog',
      'HOLDING_TYPE': 'map',
      'HOLDING_COMPRESSION': 'false'
    };
    return this.common.DBGestionAppelHolding(param).then(datas => {
      if (datas.data) {
        return datas.data || { id: id };
      }
    });
  }

  updateListContact() {
    this.client['nomclass'] = 'Client';
    const param = {
      'OPERATION': {
        'typeParam': 'int',
        'valeur': 7
      },
      'CLIENT': this.client,
      'HOLDING_SERVLET': 'DBGestionProspect',
      'HOLDING_MODULE': 'Recylog',
      'HOLDING_TYPE': 'map',
      'HOLDING_COMPRESSION': 'false',
      'CRITERE_CHANTIER': ''
    };
    return this.common.DBGestionAppelHolding(param).then(datas => {
      if (datas.data) {
        this.client['listChantier'] = datas.data['listChantier'] || this.client['listChantier'] || [];

        this.client['listChantier'].forEach(elt => {
          if (elt.dateFin) {
            elt.dateFin = moment(elt.dateFin, 'YYYY-MM-DD').format('DD/MM/YYYY');
          }
        })
        this.client['listContact'] = datas.data['listContact'] || this.client['listContact'] || [];
      }
    });
  }

  changeProspectToClient(prospect) {
    prospect.nomclass = 'Prospect';
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 15
        },
        'PROSPECT': prospect,
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        this.dupClientSelected = datas.data;
        return datas.data;
      }
    });
  }

  /**
   * @param event client selected
   */
  handleDupClientSelected(event) {
    const dupClientSelected = event && event.length === 1 && event[0].id !== 0 ? event[0] : false;
    if (dupClientSelected.table === 'prospectHolding') {
      this.getDetailProspect(dupClientSelected.id).then(datas => {
        this.changeProspectToClient(datas).then(data => {
          this.updateListContact();
        });
      });
    } else {
      this.dupClientSelected = dupClientSelected;
    }
  }

  dupliquerDevis() {
    const devisDupliquer = Object.assign({}, this.devis);
    devisDupliquer.id = 0;
    devisDupliquer.client = this.dupClientSelected || {};
    devisDupliquer.client.id = this.dupClientSelected.id;
    devisDupliquer.isHisto = false;
    devisDupliquer.user = devisDupliquer.user || {};
    devisDupliquer.user.id = this.common.user[0];
    devisDupliquer.contact = { id: 0 };
    // Calcul des dates
    const oMomentDateCreationDup = moment();
    devisDupliquer.dateCreation = oMomentDateCreationDup.format('DD/MM/YYYY');

    const oMomentDateCreation = moment(this.devis.dateCreation, 'DD/MM/YYYY HH:mm:ss');
    const oMomentdateFinValidite = moment(this.devis.dateFinValidite, 'DD/MM/YYYY HH:mm:ss');
    const diffJour = oMomentdateFinValidite.diff(oMomentDateCreation, 'days');
    if (diffJour > 0) {
      devisDupliquer.dateFinValidite = oMomentDateCreationDup.add(diffJour, diffJour > 1 ? 'days' : 'day').format('DD/MM/YYYY');
    } else {
      const dureeValiditeDevis = this.societe['dureeValiditeDevis'] || 3;
      devisDupliquer.dateFinValidite = oMomentDateCreationDup.add(dureeValiditeDevis, 'months').format('DD/MM/YYYY');
    }

    devisDupliquer.chantier = { id: 0 };

    // Positionnement valeurs ligneDevis
    const isDatePNDefaut = this.common.local.getObject('paramSociete').datePNDefaut;
    devisDupliquer.listLignes = devisDupliquer.listLignes || [];
    devisDupliquer.listLignes.forEach((ligneDevis, index) => {
      const oMomentDateDebut = moment(ligneDevis.dateDebut, 'DD/MM/YYYY HH:mm:ss');
      const oMomentDateFin = moment(ligneDevis.dateFin, 'DD/MM/YYYY HH:mm:ss');
      ligneDevis.dateDebutModel = this.common.parseDate(moment(ligneDevis.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
      ligneDevis.dateFinModel = this.common.parseDate(moment(ligneDevis.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
      const diffJourLigneDevis = oMomentDateFin.diff(oMomentDateDebut, 'days');
      ligneDevis.dateDebut = moment().format('DD/MM/YYYY');
      ligneDevis.isTarifQte = ligneDevis.isTarifQte || false;

      if (ligneDevis.article) {
        ligneDevis.article.isTarifQte = ligneDevis.isTarifQte;
      }
      // calcul ligneDevis.dateFin
      const oMomentDateFinDup = moment();
      if (isDatePNDefaut) {
        // équiv Calendar.set(Calendar.DAY_OF_YEAR, 1);
        oMomentDateFinDup.set('date', 1);
        oMomentDateFinDup.set('month', 0);
        oMomentDateFinDup.add(1, 'year');
        oMomentDateFinDup.subtract(1, 'day');
      } else if (diffJourLigneDevis > 0) {
        oMomentDateFinDup.add(diffJour, diffJour > 1 ? 'days' : 'day');
      } else {
        oMomentDateFinDup.add(3, 'months');
      }
      ligneDevis.dateFin = oMomentDateFinDup.format('DD/MM/YYYY');

      ligneDevis.chantier = { id: 0 };

      // debug erreur dupliquer histo
      ligneDevis.description = ligneDevis.description || '';
      if (ligneDevis.article && !ligneDevis.article.id) {
        ligneDevis.description = ligneDevis.description || '';
        ligneDevis.article = {
          id: 0
        }
      }
    });

    devisDupliquer.mail = false;
    devisDupliquer.imprime = false;

    this.common.closeModal();
    this.common.filtreDevisDupliquerClient = []
    return this.updateDevis(devisDupliquer, true);
  }

  searchMotifCreationDevis(event) {
    this.dataMotifCreationDevis = [];
    const list = this.common.getType('listMotifCreationDevis') || [];
    list.forEach(elt => {
      if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
        elt.libelleObjetEntite = elt.libelle;
        this.dataMotifCreationDevis.push(elt);
      }
    });
  }

  fullTable() {
    this.viewFull = !this.viewFull;
  }

  /**
   * typeClient   : devis.clients.type.id
   * zone         : devis.chantiers.zone.id
   * tarifArticle : devis.ligneDevis.article.grilleTarif
   */
  getTarifClientZone(typeClient, zone, tarifArticle) {
    // console.log(typeClient);
    console.log('zone : ' + zone);
    // console.log(tarifArticle);

    if (typeClient === 0 || zone === 0 || !tarifArticle) {
      return 0;
    }

    let tarif = 0;
    switch (typeClient) {

      case ConstanteEcorec.CLIENT_PRO:
        switch (zone) {

          case ConstanteEcorec.ZONE_1:
            tarif = tarifArticle.tarifProZone1 || 0;
            break;
          case ConstanteEcorec.ZONE_2:
            tarif = tarifArticle.tarifProZone2 || 0;
            break;
          case ConstanteEcorec.ZONE_3:
            tarif = tarifArticle.tarifProZone3 || 0;
            break;
          case ConstanteEcorec.ZONE_4:
            tarif = tarifArticle.tarifProZone4 || 0;
            break;
          case ConstanteEcorec.ZONE_5:
            tarif = tarifArticle.tarifProZone5 || 0;
            break;
          case ConstanteEcorec.ZONE_6:
            tarif = tarifArticle.tarifProZone6 || 0;
            break;
          default:
            break;
        }
        ;
        break;
      case ConstanteEcorec.CLIENT_SEMIPRO:
        switch (zone) {

          case ConstanteEcorec.ZONE_1:
            tarif = tarifArticle.tarifSemiProZone1 || 0;
            break;
          case ConstanteEcorec.ZONE_2:
            tarif = tarifArticle.tarifSemiProZone2 || 0;
            break;
          case ConstanteEcorec.ZONE_3:
            tarif = tarifArticle.tarifSemiProZone3 || 0;
            break;
          case ConstanteEcorec.ZONE_4:
            tarif = tarifArticle.tarifSemiProZone4 || 0;
            break;
          case ConstanteEcorec.ZONE_5:
            tarif = tarifArticle.tarifSemiProZone5 || 0;
            break;
          case ConstanteEcorec.ZONE_6:
            tarif = tarifArticle.tarifSemiProZone6 || 0;
            break;
          default:
            break;
        }
        ;
        break;
      case ConstanteEcorec.CLIENT_CADRE:
        switch (zone) {

          case ConstanteEcorec.ZONE_1:
            tarif = tarifArticle.tarifCadreZone1 || 0;
            break;
          case ConstanteEcorec.ZONE_2:
            tarif = tarifArticle.tarifCadreZone2 || 0;
            break;
          case ConstanteEcorec.ZONE_3:
            tarif = tarifArticle.tarifCadreZone3 || 0;
            break;
          case ConstanteEcorec.ZONE_4:
            tarif = tarifArticle.tarifCadreZone4 || 0;
            break;
          case ConstanteEcorec.ZONE_5:
            tarif = tarifArticle.tarifCadreZone5 || 0;
            break;
          case ConstanteEcorec.ZONE_6:
            tarif = tarifArticle.tarifCadreZone6 || 0;
            break;
          default:
            break;
        }
        ;
        break;
      case ConstanteEcorec.CLIENT_PARTICULIER:
        switch (zone) {

          case ConstanteEcorec.ZONE_1:
            tarif = tarifArticle.tarifPartZone1 || 0;
            break;
          case ConstanteEcorec.ZONE_2:
            tarif = tarifArticle.tarifPartZone2 || 0;
            break;
          case ConstanteEcorec.ZONE_3:
            tarif = tarifArticle.tarifPartZone3 || 0;
            break;
          case ConstanteEcorec.ZONE_4:
            tarif = tarifArticle.tarifPartZone4 || 0;
            break;
          case ConstanteEcorec.ZONE_5:
            tarif = tarifArticle.tarifPartZone5 || 0;
            break;
          case ConstanteEcorec.ZONE_6:
            tarif = tarifArticle.tarifPartZone6 || 0;
            break;
          default:
            break;
        }
        ;
        break;
      default:
        break;
    }

    return tarif;
  }

  changeDate(event, row, type) {
    this.changeDescription();
    if (moment(event).isValid()) {
      row[type] = moment(event).format('DD/MM/YYYY');
    } else {
      row[type] = '';
    }
  }

  copieDateDevis() {
    this.changeDescription();
    const dateDeb = this.common.parseDate(this.detail['dateCreation']);
    const dateF = this.common.parseDate(this.detail['dateFinValidite']);
    this.detail['listLignes'] = this.detail['listLignes'] || []
    this.detail['listLignes'].forEach((elt, index) => {
      elt.dateDebut = this.detail['dateCreation'];
      elt.dateFin = this.detail['dateFinValidite'];
      elt.dateDebutModel = dateDeb;
      elt.dateFinModel = dateF;
    });
  }

  searchArticleContenu(event, rowIndex) {
    this.artContenu = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];

    // Article non prestation
    const param = 22;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('.artCont' + rowIndex).trigger('click');
      if (datas.data) {
        this.artContenu = [...this.artContenu, ...(datas.data || [])];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  toggleExpandRow(row) {
    this.rowToExpand = row;
    this.table.rowDetail.toggleExpandRow(row);
  }

  onDetailToggle(event) {
  }


  searchContenant(event?) {
    this.listContenant = [];
    const liste = this.common.getType('listetypeContenant') || [];
    liste.forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelle = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? elt.uniteCont.libelle : '');
      elt.libelleObjetEntite = elt.libelle;
      this.listContenant.push(elt);
      // }
    });
  }

  saveDetailSupp(event) {
    // console.log(event);
    this.rowToExpand = event;
    this.isEdit = true;

    // console.log(this.detail['listLignes']);
  }

  searchAgence() {
    // selon client
    const param = {
      'servlet': 'DBAgenceGet',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.client ? this.client.id : '0'
        },
        'CRITERE': ''
      }
    };

    this.common.post('', { param: param }).then(datas => {
      // this.listAgence = datas.data;
      this.listAgence = [...[{ id: 0, libelleObjetEntite: 'Toutes' }], ...(datas.data || [])];
    });
  }

  getListSection() {
    // selon client
    const param = {
      'servlet': 'DBGestionObjetEntite',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'DRAPEAUX_OPERATIONS': {
          'typeParam': 'int',
          'valeur': 0x00000020
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        this.listSection = datas.data.SECTION_DEVIS_LISTE || [];
      }
    });
  }
  toogleSlide() {
    this.isToogle = !this.isToogle;
  }

  fonctionEnvoieMail() {
    const FIPDnd = this.recuperationArticleisNotDIS(this.detail);
    const existeFIPDnd = (FIPDnd || []).filter(Ligne => (Ligne.article && Ligne.article.id > 0 && (Ligne.article.famille === '1' || Ligne.article.famille === '3')))
    if (existeFIPDnd && existeFIPDnd.length && (this.detail['client'] && !this.detail['client'].isNonSoumisFIP)) {
      if (this.detail && (!this.detail['contact'] || (this.detail['contact'] && !this.detail['contact'].id) ||
        (this.detail['contact'] && this.detail['contact'].id && (!this.detail['contact'].nom || !this.detail['contact'].prenom || !this.detail['contact'].mail)))) {
        this.isEnvoiParEmail = false;
        this.selectedFpFIP = {};

        this.error = (this.detail['contact'] && this.detail['contact'].id && (!this.detail['contact'].nom || !this.detail['contact'].prenom || !this.detail['contact'].mail)) ?
          ('Le nom, prénom et e-mail du contact doivent être renseigné.') : 'Un contact doit être renseigné';

        this.common.openModal(this.modalService, this.msg);
      } else {
        if (this.existeDNDnonSignee()) {
          this.getFormatPersoFIPMail(37);
        } else {
          this.envoieMailFIP();
        }
      }
    } else {
      this.envoieMailFIP();
    }
  }

  async initialiserEnvoiParMail() {
    this.isEnvoiParEmail = true;
    this.selectedFpFIP = {};
    if (this.societe['gestionFIP']) {
      if (this.add) {
        this.createDevis(true).then(data => {
          this.add = false;
          this.fonctionEnvoieMail()
        })
      } else {
        const isAdd = this.detail['id'] == 0;
        this.updateDevis(this.detail, isAdd, false, true).then(retourSave => {
          this.fonctionEnvoieMail();
        });
      }
    } else {
      this.getFormatperso();
    }
  }

  selectFPFipMail(item) {
    if (this.typeFIP === 37) {
      this.selectedFpFIP['dnd'] = item;
    } else {
      this.selectedFpFIP['dd'] = item;
    }
  }

  envoieMailFIP() {
    if (this.societe['gestionFIP'] && (this.detail['client'] && !this.detail['client'].isNonSoumisFIP)) {
      if (this.typeFIP !== 38) {
        const existeFIPDd = this.recuperationArticleisDIS(this.detail)
        if (existeFIPDd && existeFIPDd.length) {
          if (this.detail && (!this.detail['contact'] || (this.detail['contact'] && !this.detail['contact'].id) ||
            (this.detail['contact'] && this.detail['contact'].id && (!this.detail['contact'].nom || !this.detail['contact'].prenom || !this.detail['contact'].mail)))) {
            this.isEnvoiParEmail = false;
            this.selectedFpFIP = {};

            this.error = (this.detail['contact'] && this.detail['contact'].id && (!this.detail['contact'].nom || !this.detail['contact'].prenom || !this.detail['contact'].mail)) ?
              ('Le nom, prénom et e-mail du contact doivent être renseigné.') : 'Un contact doit être renseigné';
            this.common.openModal(this.modalService, this.msg);
          } else {
            if (this.existeDDnonSignee()) {
              this.getFormatPersoFIPMail(38);
            } else {
              this.getFormatperso()
            }
          }
        } else {
          this.getFormatperso();
        }
      } else {
        this.getFormatperso();
      }
    } else {
      this.getFormatperso();
    }
  }

  getFormatPersoFIPMail(type) {
    console.log('Calling getFormatPersoFIPMail()', this.formatPesroFIPMail);
    this.typeFIP = type;
    const that = this;
    that.formatPerso = [];
    GestionFormat.getFormatperso(type, this.common).then(datasFormat => {
      if (datasFormat.data) {
        that.formatPerso = datasFormat.data;
        if (that.formatPerso.length > 1) {
          that.formatprs = that.formatPerso[0];
          that.common.openModal(that.modalService, that.formatPesroFIPMail);
        } else {
          if (that.formatPerso.length === 1) {
            if (this.typeFIP === 37) {
              that.selectedFpFIP['dnd'] = that.formatPerso[0];
              that.envoieMailFIP();
            } else {
              that.selectedFpFIP['dd'] = that.formatPerso[0];
              this.getFormatperso();
            }
          } else {
            that.common.openModal(that.modalService, that.formatPesroFIPMail);
          }
        }
      } else {
        if (datasFormat.message) {
          this.error = datasFormat.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }
    });
  }

  envoyerParEmailAdd(isdepuisinitiEnvoiParMail?) {
    console.log('Calling envoyerParEmailAdd()');
    if (!isdepuisinitiEnvoiParMail && (!this.formatprs || (this.formatprs && !this.formatprs['id']))) {
      this.error = 'Vous devez sélectionner un format paramétrable.';
      this.common.openModal(this.modalService, this.msg);
      return;
    }
    this.createDevis(true).then(data => {
      this.add = false;
      this.isEnvoiParEmail = true;
      this.selectedFpFIP = {};
      if (this.societe['gestionFIP']) {
        const FIPDnd = this.recuperationArticleisNotDIS(data);
        const existeFIPDnd = (FIPDnd || []).filter(Ligne => (Ligne.article && Ligne.article.id > 0 && (Ligne.article.famille === '1' || Ligne.article.famille === '3')))
        if (existeFIPDnd && existeFIPDnd.length) {
          if (this.detail && (!this.detail['contact'] || (this.detail['contact'] && !this.detail['contact'].id) ||
            (this.detail['contact'] && this.detail['contact'].id && (!this.detail['contact'].nom || !this.detail['contact'].prenom || !this.detail['contact'].mail)))) {
            this.isEnvoiParEmail = false;
            this.selectedFpFIP = {};

            this.error = (this.detail['contact'] && this.detail['contact'].id && (!this.detail['contact'].nom || !this.detail['contact'].prenom || !this.detail['contact'].mail)) ?
              ('Le nom, prénom et e-mail du contact doivent être renseigné.') : 'Un contact doit être renseigné';

            this.common.openModal(this.modalService, this.msg);
          } else {

            this.getFormatPersoFIPMail(37);
          }
        } else {
          this.envoieMailFIP();
        }
      } else {
        this.envoyerParEmail();
      }
    });
  }

  /**
   * FacturationBons.java -> envoyerBonParMail()
   */
  envoyerParEmail() {
    console.log('Calling envoyerParEmail()');
    this.devisAEnvoyerParMailCourant = this.detail;
    // console.log(this.devisAEnvoyerParMailCourant);

    // Prendre les infos de l'utilisateur
    this.envoiemail_signatureTexte = this.user['signatureDevis'] || '';
    this.envoiemail_signatureImageTemp = this.user['imageSignatureDevis'].nomFichier || '';
    this.envoiemail_signatureImage = '';

    // Les infos mails de l'utilisateur
    this.envoimail_siteEntrepriseAdresseExpDevis = this.user['siteParamMail'].adresseExpDevis || '';
    this.envoimail_siteEntrepriseAdresseCopieDevis = this.user['siteParamMail'].adresseCopieDevis || '';
    this.envoimail_siteEntrepriseTitreMailDevis = this.user['siteParamMail'].titreMailDevis || '';
    this.envoimail_siteEntrepriseCorpsMailDevis = this.user['siteParamMail'].corpsMailDevis || '';

    // Prendre les infos de site
    if (!this.envoiemail_signatureTexte) {
      this.envoiemail_signatureTexte = this.siteUtilisateur['signatureDevis'] || '';
    }

    if (!this.envoiemail_signatureImageTemp) {
      this.envoiemail_signatureImage = this.siteUtilisateur['imageSignatureDevis'].nomFichier;
    } else {
      this.envoiemail_signatureImage = this.envoiemail_signatureImageTemp;
    }
    this.envoiemail_finalSignatureImage = this.envoiemail_signatureImage;

    // Les infos mails
    this.envoimail_siteEntrepriseAdresseExpDevis = this.envoimail_siteEntrepriseAdresseExpDevis ||
      this.siteUtilisateur['siteParamMail'].adresseExpDevis || '';
    this.envoimail_siteEntrepriseAdresseCopieDevis = this.envoimail_siteEntrepriseAdresseCopieDevis ||
      this.siteUtilisateur['siteParamMail'].adresseCopieDevis || '';
    this.envoimail_siteEntrepriseTitreMailDevis = this.envoimail_siteEntrepriseTitreMailDevis ||
      this.siteUtilisateur['siteParamMail'].titreMailDevis || '';
    this.envoimail_siteEntrepriseCorpsMailDevis = this.envoimail_siteEntrepriseCorpsMailDevis ||
      this.siteUtilisateur['siteParamMail'].corpsMailDevis || '';

    this.envoiemail_destMail = this.devisAEnvoyerParMailCourant['client'].adresseDestClient &&
      this.devisAEnvoyerParMailCourant['client'].adresseDestClient.adresseMailDevis ?
      this.devisAEnvoyerParMailCourant['client'].adresseDestClient.adresseMailDevis : '';

    let adresseMail = '';
    if (this.devisAEnvoyerParMailCourant.contact && this.devisAEnvoyerParMailCourant.contact.mail &&
      this.devisAEnvoyerParMailCourant.contact.mail.indexOf('@') > 0) {
      adresseMail = this.devisAEnvoyerParMailCourant.contact.mail;
    } else if (this.devisAEnvoyerParMailCourant['client'].mailFacturation) {
      adresseMail = this.devisAEnvoyerParMailCourant['client'].mailFacturation;
    } else {
      adresseMail = this.devisAEnvoyerParMailCourant['client'].mail || '';
    }

    // Adresse émetteur Mail
    let adresseEmetteurMail = '';
    if (this.devisAEnvoyerParMailCourant.user && this.devisAEnvoyerParMailCourant.user.mail &&
      this.devisAEnvoyerParMailCourant.user.mail.indexOf('@') > 0) {
      adresseEmetteurMail = this.devisAEnvoyerParMailCourant.user.mail;
    } else if (this.devisAEnvoyerParMailCourant['client'].userCommercial &&
      this.devisAEnvoyerParMailCourant['client'].userCommercial.mail) {
      adresseEmetteurMail = this.devisAEnvoyerParMailCourant['client'].userCommercial.mail;
    } else if (this.envoimail_siteEntrepriseAdresseExpDevis) {
      adresseEmetteurMail = this.envoimail_siteEntrepriseAdresseExpDevis;
    } else {
      adresseEmetteurMail = this.societe['mail'];
    }

    this.envoiemail_destMail = this.envoiemail_destMail || adresseMail || '';
    this.envoiemail_expMail = this.envoimail_siteEntrepriseAdresseExpDevis || this.societe['mail'];
    this.envoiemail_copieMail = this.envoimail_siteEntrepriseAdresseCopieDevis || this.siteUtilisateur['mail'] || '';
    this.envoiemail_titreMail = this.envoimail_siteEntrepriseTitreMailDevis || this.SUJET_MAIL_DEVIS_ECOCRM;
    this.envoiemail_corpsMail = this.envoimail_siteEntrepriseCorpsMailDevis || this.CONTENU_MAIL_DEVIS_ECOCRM;

    this.envoiemail_titreMail = this.remplacerVariableCorpsMail(this.envoiemail_titreMail, this.envoiemail_signatureTexte);
    this.envoiemail_corpsMail = this.remplacerVariableCorpsMail(this.envoiemail_corpsMail, this.envoiemail_signatureTexte);
    this.envoiemail_corpsMail += '\n\n' + this.envoiemail_signatureTexte;

    this.envoiemail_format = this.devisAEnvoyerParMailCourant.isFactureProFormat ?
      this.siteUtilisateur['formatBonAdmin'] : this.siteUtilisateur['formatFactureProformat'];

    if (this.accepteDevisMail) {
      const envoiemail_destMail = this.devisAEnvoyerParMailCourant['client'].adresseDestClient &&
        this.devisAEnvoyerParMailCourant['client'].adresseDestClient.adresseMailDevis ?
        this.devisAEnvoyerParMailCourant['client'].adresseDestClient.adresseMailDevis : '';

      this.datamail = {
        titre: 'CR Depot Contenant du devis ' + this.devisAEnvoyerParMailCourant['numDevis'],
        expediteur: this.user['mail'],
        destinataire: envoiemail_destMail,
        cc: '',
        bcc: '',
        sujet: 'CR Depot Contenant du devis ' + this.devisAEnvoyerParMailCourant['numDevis'],
        contenu: '',
      };
      this.aUnSignature = false;
    } else {
      this.datamail = {
        titre: 'Envoi du devis ' + this.devisAEnvoyerParMailCourant['numDevis'] + ' par email',
        expediteur: this.envoiemail_expMail,
        destinataire: this.envoiemail_destMail,
        cc: this.envoiemail_copieMail,
        bcc: '',
        sujet: this.envoiemail_titreMail,
        contenu: this.envoiemail_corpsMail,
      };
      this.aUnSignature = this.envoiemail_finalSignatureImage ? true : false;
    }

    this.common.closeModal(); // Ferme le choix du format
    // this.common.openModal(this.modalService, this.mail, true);
    this.common.openModalDmdEcoGED(this.modalService, this.mail);
  }

  remplacerVariableCorpsMail(chaine, strSignatureTexte) {
    let retour = chaine ? chaine : '';
    this.envoiemail_strDevis = 'Le devis';
    this.envoiemail_strType = 'Devis';
    this.envoiemail_strNumDevis = this.devisAEnvoyerParMailCourant['numDevis'];
    this.envoiemail_strNomSociete = this.societe['nom'];

    retour = this.replaceAll(retour, '@bonOuFactureEcofact', this.envoiemail_strDevis);
    retour = this.replaceAll(retour, '@TypePiece', this.envoiemail_strType);
    retour = this.replaceAll(retour, '@numDevisEcocrm', this.envoiemail_strNumDevis);
    retour = this.replaceAll(retour, '@nomSociete', this.envoiemail_strNomSociete);
    retour = this.replaceAll(retour, '@signatureTexteEcocrmDevis', strSignatureTexte);

    return retour;
  }

  replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  validerPanneauMail(panneauEmail) {
    console.log('Calling validerPanneauMail(' + (this.accepteDevisMail ? 'this.accepteDevisMail' : '') + ')');
    const ctrl = this;
    if (this.accepteDevisMail) {
      ctrl.envoyerCRParEmail(
        ctrl.devisAEnvoyerParMailCourant,
        ctrl.envoiemail_format,
        ctrl.formatprs['id'],
        panneauEmail.expediteur,
        panneauEmail.destinataire,
        panneauEmail.cc,
        panneauEmail.bcc,
        panneauEmail.sujet,
        panneauEmail.contenu,
        panneauEmail.isEnvoiImageSignature ? this.envoiemail_finalSignatureImage : ''
      );
    } else {
      ctrl.envoyerBonParEmail(
        ctrl.devisAEnvoyerParMailCourant,
        ctrl.envoiemail_format,
        ctrl.formatprs['id'],
        panneauEmail.expediteur,
        panneauEmail.destinataire,
        panneauEmail.cc,
        panneauEmail.bcc,
        panneauEmail.sujet,
        panneauEmail.contenu,
        panneauEmail.isEnvoiImageSignature ? this.envoiemail_finalSignatureImage : '',
        panneauEmail['listDocumentsPJ'] || []
      );
    }

  }

  annulerPanneauMail() {
    if (this.accepteDevisMail) {
      this.etapeSuivantApresDepot();
    }
  }

  envoyerBonParEmail(d, format, formatParamBon, expediteurEmail, destinataireEmail,
    ccEmail, bcc, sujetEmail, contenuEmail, signatureImage, listDocumentsPJ) {
    // loading
    this.common.closeModal();
    this.common.openAcompteModal(this.modalService, this.loading);

    // Enregistre le devis avant l'envoi par mail s'il peut être modifié (Btn Enregistrer visible)
    if (!this.isDepuisFacturation && !this.detail['isHisto'] && this.isDroitModifDevis) {
      const isAdd = this.detail['id'] == 0;
      this.updateDevis(this.detail, isAdd, true).then(retourSave => {
        this.callSendMailDevisServlet(d, format, formatParamBon, expediteurEmail, destinataireEmail,
          ccEmail, bcc, sujetEmail, contenuEmail, signatureImage, listDocumentsPJ);
      });
    } else {
      this.callSendMailDevisServlet(d, format, formatParamBon, expediteurEmail, destinataireEmail,
        ccEmail, bcc, sujetEmail, contenuEmail, signatureImage, listDocumentsPJ);
    }
  }

  callSendMailDevisServlet(d, format, formatParamBon, expediteurEmail, destinataireEmail,
    ccEmail, bcc, sujetEmail, contenuEmail, signatureImage, listDocumentsPJ) {
    const ctrl = this;
    d['nomclass'] = 'Devis';
    const CLEF_FORMAT_PARAMETRABLE_FIPDND = this.societe['gestionFIP'] ? (this.selectedFpFIP.dnd && this.selectedFpFIP.dnd.id ? this.selectedFpFIP.dnd.id : 0) : 0;
    const CLEF_FORMAT_PARAMETRABLE_FIPDD = this.societe['gestionFIP'] ? (this.selectedFpFIP.dd && this.selectedFpFIP.dd.id ? this.selectedFpFIP.dd.id : 0) : 0;
    const param = {
      'servlet': 'DBImprimerDevisParMail',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'data': {
        'DEVIS': d,
        'CLEF_USER': { 'typeParam': 'int', 'valeur': this.common.user[0] },
        'CLEF_SITE': { 'typeParam': 'int', 'valeur': this.common.user[2] },
        // 'FORMAT': {'typeParam': 'string', 'valeur': format},
        'CLEF_FORMAT_PARAMETRABLE': { 'typeParam': 'int', 'valeur': formatParamBon },
        'CLEF_FORMAT_PARAMETRABLE_FIPDND': { 'typeParam': 'int', 'valeur': CLEF_FORMAT_PARAMETRABLE_FIPDND },
        'CLEF_FORMAT_PARAMETRABLE_FIPDD': { 'typeParam': 'int', 'valeur': CLEF_FORMAT_PARAMETRABLE_FIPDD },
        'EXPEDITEUR': { 'typeParam': 'string', 'valeur': expediteurEmail },
        'DESTINATAIRE': { 'typeParam': 'string', 'valeur': destinataireEmail },
        'CC': { 'typeParam': 'string', 'valeur': ccEmail || '' },
        'BCC': { 'typeParam': 'string', 'valeur': bcc },
        'SUJET': { 'typeParam': 'string', 'valeur': sujetEmail || '' },
        'CONTENU': { 'typeParam': 'string', 'valeur': contenuEmail || '' },
        'IMAGE_SIGNATURE': { 'typeParam': 'string', 'valeur': signatureImage || '' },
      }
    };

    if (format) {
      param['data']['FORMAT'] = format;
    }

    if (this.common.isProspectHolding) {
      const nombd = this.common.local.getObject('nomBDHolding') ? this.common.local.getObject('nomBDHolding').nomBDHolding : '';
      param['data']['BD_HOLDING'] = nombd;
    }

    if (listDocumentsPJ && listDocumentsPJ.length) {
      param['data']['PJ_SUPP'] = listDocumentsPJ;
    }

    return this.common.post('', { param: param }).then(datas => {
      // ctrl.common.closeModal();
      if (datas['data'] && datas['data'] === 'OK') {
        this.common.closeAcopteModal();
        if (this.accepteDevisMail) {
          this.error = 'Un email de compte de rendu de Depot Contenant sur le devis ' +
            this.detail['numDevis'] + ' a été envoyé au client.';
          this.common.openModal(this.modalService, this.msgMail);
          this.accepteDevisMail = false;
        } else {
          this.error = 'Les mails ont été envoyés avec succès';
          this.common.openModal(this.modalService, this.msg);
          if (CLEF_FORMAT_PARAMETRABLE_FIPDD || CLEF_FORMAT_PARAMETRABLE_FIPDND) {
            // A ajouter getDetail
            this.getDetail(this.detail, true);
          }
        }

      } else {
        ctrl.common.closeAcopteModal();
        ctrl.error = 'Un problème est survenu lors de l\'envoi des mails';
        ctrl.common.openModal(ctrl.modalService, ctrl.msg);
        this.accepteDevisMail = false;
      }
    }).catch(err => {
      ctrl.common.closeAcopteModal();
      this.accepteDevisMail = false;
    });
  }

  envoyerCRParEmail(d, format, formatParamBon, expediteurEmail, destinataireEmail,
    ccEmail, bcc, sujetEmail, contenuEmail, signatureImage) {
    // loading
    const ctrl = this;
    this.common.closeModal();

    this.common.openAcompteModal(this.modalService, this.loading);
    d['nomclass'] = 'Devis';
    const nombd = this.common.local.getObject('nomBDHolding') ? this.common.local.getObject('nomBDHolding').nomBDHolding : '';
    const param = {
      'servlet': 'DBImprimeDevisCRDepotContenant',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'data': {
        'DEVIS': d,
        'CLEF_USER': { 'typeParam': 'int', 'valeur': this.common.user[0] },
        'CLEF_SITE': { 'typeParam': 'int', 'valeur': this.common.user[0] },
        'LISTE_CLEF_MOUV': this.LISTE_CLEF_MOUV,
        'CLEF_FORMAT_PARAMETRABLE': { 'typeParam': 'int', 'valeur': formatParamBon },
        'EXPEDITEUR': { 'typeParam': 'string', 'valeur': expediteurEmail },
        'DESTINATAIRE': { 'typeParam': 'string', 'valeur': destinataireEmail },
        'CC': { 'typeParam': 'string', 'valeur': ccEmail || '' },
        'BCC': { 'typeParam': 'string', 'valeur': bcc },
        'SUJET': { 'typeParam': 'string', 'valeur': sujetEmail || '' },
        'CONTENU': { 'typeParam': 'string', 'valeur': contenuEmail || '' },
        'BD_HOLDING': nombd || ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      this.LISTE_CLEF_MOUV = [];
      ctrl.common.closeModal();
      if (datas['data']) {
        this.common.closeAcopteModal();
        this.error = 'Un email de compte de rendu de Depot Contenant sur le devis ' +
          this.detail['numDevis'] + ' a été envoyé au client.';
        this.common.openModal(this.modalService, this.msgMailCR);
        this.accepteDevisMail = false;
      } else {
        ctrl.common.closeAcopteModal();
        ctrl.error = 'Un problème est survenu lors de l\'envoi des mails';
        ctrl.common.openModal(ctrl.modalService, ctrl.msg);
        this.accepteDevisMail = false;

        this.etapeSuivantApresDepot();
      }
    });
  }

  handleBtnChoixFormat() {
    // console.log('this.isEnvoiParEmail=' + this.isEnvoiParEmail);
    if (this.accepteDevisMail) {
      this.envoyerParEmail();
    } else {
      if (this.isEnvoiParEmail) {
        this.isEnvoiParEmail = false;
        this.add ? this.envoyerParEmailAdd() : this.envoyerParEmail();
      } else {
        this.add ? this.printAdd() : this.print();
      }
    }

  }

  imprimeCAP(isImpressionFP) {
    this.updateDevis(this.detail, true, false, true).then(() => {
      const lstLigneValid = [];
      let numLigne = '';
      this.devis['listLignes'] = this.devis['listLignes'] || [];
      this.devis['listLignes'].forEach((ligneDevis, index) => {
        console.log(ligneDevis);
        if (ligneDevis.article && ligneDevis.article.id) {
          if (ligneDevis.article && ligneDevis.article.isDIS) {
            if (ligneDevis.contenant.id === 0) {
              let j = index;
              j++;
              numLigne += '\n Ligne ' + j + ' : ' + ligneDevis.article.libelle;
            } else {
              lstLigneValid.push(ligneDevis);
            }

          } else if (this.societe['BSDDND'] && ligneDevis.article && !ligneDevis.article.isDIS &&
            (ligneDevis.article.familleArticle.id === 1 || ligneDevis.article.familleArticle.id === 3)) {
            if (ligneDevis.contenant.id === 0) {
              let j = index;
              j++;
              numLigne += '\n Ligne ' + j + ' : ' + ligneDevis.article.libelle;
            } else {
              lstLigneValid.push(ligneDevis);
            }

          }
        }
      });

      if (numLigne !== '') {
        this.error = `Les articles suivant(s) n'ont pas de contenant :` + numLigne;
        this.common.openModal(this.modalService, this.msg);
      } else if (lstLigneValid.length <= 0) {
        this.error = `Il n'y a pas des dechets dangéreux à imprimer :`;
        this.common.openModal(this.modalService, this.msg);
      } else if (lstLigneValid.length > 0) {
        this.devis['listLignes'] = lstLigneValid;
        if (isImpressionFP) {
          this.getFormatpersoCAP();
        }
      }
    });
  }

  getFormatpersoCAP() {
    const param = {
      'servlet': 'DBGestionFormatParametrable',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLEF_TYPE_FORMAT': {
          'typeParam': 'int',
          'valeur': this.common.TYPE_FORMAT_PARAMETRABLE_CAP
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.formatPersoCAP = datas.data;
      if (this.formatPersoCAP.length > 1) {
        this.formatprsCAP = this.formatPersoCAP[0];
        // open modal
        this.common.openModal(this.modalService, this.formatCAP);
      } else {
        // get pdf to print
        if (this.formatPersoCAP.length === 1) {
          this.formatprsCAP = this.formatPersoCAP[0];
          this.printCAP(true);
        } else {
          this.common.openModal(this.modalService, this.formatCAP);
        }
      }
    });
  }

  printCAP(isImpressionFP) {
    let format = 'formatCAPEcocrm.xml';
    if (!isImpressionFP) {
      const site = this.getDetailSite();
      if (site) {
        format = site.formatCAPEcocrm;
      }

    }
    const param = {
      'servlet': 'DBImprimeCAP',
      'module': 'Ecocrm',
      'type': 'liste',
      'compression': 'false',
      'pathImpression': 'Ecocrm/tmp/CAP/',
      'data': [
        ['DBImprimeCAP'],
        this.devis,
        {
          'typeParam': 'string',
          'valeur': '' + this.common.user[0]
        },
        {
          'typeParam': 'string',
          'valeur': format
        },
        {
          'typeParam': 'string',
          'valeur': this.formatprsCAP ? '' + this.formatprsCAP['id'] : '0'
        }
      ]
    };

    this.common.post('', { param: param }).then(datas => {
      if (datas.data && datas.data.length) {
        this.common.openFile(datas.data[0]);
        this.formatprsCAP = '';
        this.returnList();
      } else {
        if (datas.message) {
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
          this.returnList();
        }
      }
    }).catch(err => this.returnList());

  }

  getDetailSite() {
    let siteEntrePrise;
    const param = {
      'servlet': 'DBGetInfoSite',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetInfoSite', '' + this.common.user[2]]
    };
    this.common.post('', { param: param }).then(dt => {
      if (dt.message) {
        this.error = dt.message;
        this.common.openModal(this.modalService, this.msg);
      } else {
        siteEntrePrise = dt.data[0];
      }
    });
    return siteEntrePrise;
  }

  async getSocieteFille() {
    const param = {
      'OPERATION': {
        'typeParam': 'int',
        'valeur': 1
      },
      'SOUS_OPERATION': {
        'typeParam': 'int',
        'valeur': 2
      },
    };

    await this.common.DBGestionParamHoldingAngular(param).then(dt => {
      if (dt && dt.data !== null) {
        this.listeSociete = dt.data || [];
      }
    });
  }

  // Commit getLibelleChantier
  getLibelleChantier(item) {
    let libelle = '';
    if (item) {
      libelle = `${item.numChantier || ''}${item.responsable ? ' / ' : ''}
      ${item.responsable || ''}${item.adresse1 ? ' / ' : ''}${item.adresse1 || ''}
      ${item.ville ? ' / ' : ''}${item.ville || ''}`;
    }
    return libelle;
  }

  changeDateModel(event, type) {
    this.isEdit = true;
    if (moment(event).isValid()) {
      this.detail[type] = moment(event).format('DD/MM/YYYY');
    } else {
      this.detail[type] = !event ? moment().format('DD/MM/YYYY') : '';
    }
  }

  insertDevisFct(prix) {
    console.log(prix);
    let dateDeb;
    let dateF;
    if (this.societe['datePNDefaut']) {
      dateDeb = this.common.parseDate(moment().startOf('year').format('MM/DD/YYYY'));
      dateF = this.common.parseDate('31/12/' + new Date().getFullYear());
    } else {
      dateDeb = this.common.parseDate(this.detail['dateCreation']);
      dateF = this.common.parseDate(this.detail['dateFinValidite']);
    }
    console.log(this.societe['datePNDefaut'], dateDeb, dateF)
    prix.dateDebut = moment(dateDeb).format('DD/MM/YYYY');
    prix.dateFin = moment(dateF).format('DD/MM/YYYY');
    prix.dateDebutModel = dateDeb;
    prix.dateFinModel = dateF;
    prix.id = (-1 * (this.detail['listLignes'].length + 1)),
      prix.index = this.detail['listLignes'].length;
    prix.idNouveauObjet = -1 * (this.detail['listLignes'].length + 1);
    prix.quantite = 1;
    prix.accept = true;
    prix.pourcentageRemise = 0;
    prix.modifArticle = true;

    this.calculMontant(prix);
    if (!this.detail['listLignes'] || (this.detail['listLignes'] && !this.detail['listLignes'].length)) {
      this.renderTable = false;
      setTimeout(function () {
        ctrl.renderTable = true;
      }, 100);
    } else {
      const ligne1 = this.detail['listLignes'][0];
      prix.dateDebut = ligne1.dateDebut;
      prix.dateFin = ligne1.dateFin;
      prix.dateDebutModel = ligne1.dateDebutModel;
      prix.dateFinModel = ligne1.dateFinModel;
    }
    this.detail['listLignes'].push(prix);
    this.detail['listLignes'] = [...this.detail['listLignes']];

    this.prixNego = !this.prixNego;
    this.changeDescription();
    this.getPrix();
    const ctrl = this;
    const idx = this.detail['listLignes'].length - 1;

    setTimeout(function () {
      $('.article' + (idx < 0 ? 0 : idx)).focus();
    }, 600);
  }

  calcHeightDatatable() {
    const offsetHeightAddLigne = document.getElementById('addLigne') && document.getElementById('addLigne').offsetHeight || 0;
    const offsetHeightHeaderBon = document.getElementById('headerBon') && document.getElementById('headerBon').offsetHeight || 0;

    return offsetHeightAddLigne + offsetHeightHeaderBon + 75;
  }

  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);
    const row = this.selected[0] || { id: 0 };
    this.selectRow(row)
  }

  checkPrixMinMax(rowToCheck) {
    console.log('Calling checkPrixMinMax');
    let tarif = rowToCheck.tarif;
    const art = rowToCheck.article;
    rowToCheck.article = rowToCheck.article || {};
    rowToCheck.article.listePrixMinMax = rowToCheck.article.listePrixMinMax || [];
    const idTypeClient = (this.detail && this.detail['client'] && this.detail['client'].type && this.detail['client'].type.id) ?
      this.detail['client'].type.id : 0;
    let tarifA = this.common.getTarifMinMaxArticleClient(rowToCheck.article.listePrixMinMax, tarif,
      idTypeClient, true);
    if (tarifA !== tarif) {
      tarif = tarifA;
      this.error = 'Le tarif saisi est inférieur au prix minimum' +
        '\n autoris\u00e9 de : ' + art.code + '.';
      this.common.openModal(this.modalService, this.msg);
      rowToCheck.tarif = tarif;
    } else {
      tarifA = this.common.getTarifMinMaxArticleClient(rowToCheck.article.listePrixMinMax, tarif,
        idTypeClient, false);
      if (tarifA !== tarif) {
        tarif = tarifA;
        this.error = 'Le tarif saisi est supérieur au prix maximum' +
          '\n autorisé de : ' + art.code + '.';
        this.common.openModal(this.modalService, this.msg);
        rowToCheck.tarif = tarif;
      }
    }

    this.getPrix();
  }

  tabChanged(tabChangeEvent): void {
    console.log('tabChangeEvent => ', tabChangeEvent);
    console.log('index => ', tabChangeEvent.index);
    this.indexSection = tabChangeEvent.index;
    this.selectedSection = this.listSection && this.listSection[this.indexSection] ? this.listSection[this.indexSection] : { id: 0 };
    this.getLigneAffiche();
  }

  getLigneAffiche() {
    if (this.detail['lignesParSection']) {
      // const section = this.listSection && this.listSection[this.indexSection] ? this.listSection[this.indexSection] : { id: 0 };
      this.listSection = this.listSection || [];
      this.listSection.forEach(elt => {
        elt.ligneAffiche = this.detail['listLignes'].filter(element => element.sectionDevis && elt.id === element.sectionDevis.id) || [];
        elt.ligneAffiche = [...elt.ligneAffiche];
      });
    }
  }

  changeLigneParSection() {
    if (this.detail['lignesParSection']) {
      this.indexSection = 0;
      this.selectedSection = this.listSection && this.listSection[this.indexSection] ? this.listSection[this.indexSection] : { id: 0 };
      const section = this.listSection && this.listSection.length && this.listSection[this.indexSection]
        ? this.listSection[this.indexSection] : { id: 0 };
      this.detail['listLignes'].forEach(element => {
        element.sectionDevis = {
          id: section.id
        };
      });
      this.getLigneAffiche();
    }
  }

  avantAppelFormatPersoDND() {
    const existeLigneNonDIS = (this.detail['listLignes'] || []).filter(ligne => ligne.article && ligne.article.id > 0 && !ligne.article.isDIS);
    if (existeLigneNonDIS && existeLigneNonDIS.length && this.existeDNDnonSignee()) {
      this.getFormatPersoFIP(37)
    } else {
      this.gestionFIPDD();
    }
  }

  avantAppelFormatPersoDD() {
    const existeLigneDIS = (this.detail['listLignes'] || []).filter(ligne => ligne.article && ligne.article.id > 0 && ligne.article.isDIS);
    if (existeLigneDIS && existeLigneDIS.length && this.existeDDnonSignee()) {
      this.getFormatPersoFIP(38)
    } else {
      // A ajouter getDetail
      this.getDetail(this.detail, true)
    }
  }

  getFormatPersoFIP(type) {
    const that = this;
    GestionFormat.getFormatperso(type, this.common).then(datasFormat => {
      if (datasFormat.data) {
        that.formatPerso = datasFormat.data;
        if (that.formatPerso.length > 1) {
          that.formatprs = that.formatPerso[0];
          that.common.openModal(that.modalService, that.formatPesroFIP);
        } else {
          if (that.formatPerso.length === 1) {
            that.formatprs = that.formatPerso[0];
            that.printFIP();
          } else {
            that.common.openModal(that.modalService, that.formatPesroFIP);
          }
        }
      } else {
        if (datasFormat.message) {
          this.error = datasFormat.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }
    });
  }

  printFIP() {
    const DEVIS = this.detail || {};
    DEVIS['nomclass'] = 'Devis';
    const param = {
      'servlet': this.isDD ? 'DBImprimeFIPDD' : 'DBImprimeFIP',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLEF_FORMAT_PARAMETRABLE': {
          'typeParam': 'int',
          'valeur': this.formatprs ? this.formatprs['id'] || 0 : 0
        },
        'DEVIS': DEVIS,
        '"CLEF_USER" ': {
          'typeParam': 'int',
          'valeur': this.common.user[0] || 0
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2] || 0
        },
      }
    };

    return this.common.post('', { param: param }, true).then(datas => {
      if (datas.data && datas.data.length) {
        datas.data.forEach(doc => {
          this.common.openFile(doc);
        });
        if (!this.isDD) {
          this.gestionFIPDD();
        } else {
          // A ajouter getDetail
          this.getDetail(this.detail, true)
        }
        // if (this.isDD) {
        //   this.ouvrirRenseignementsFIPDD(this.detail);
        // } else {
        //   this.ouvrirRenseignementsFIP(this.detail);
        // }
      } else {
        if (!this.isDD) {
          this.gestionFIPDD();
        } else {
          // A ajouter getDetail
          this.getDetail(this.detail, true)
        }
      }
    });

  }

  gestionFIPDND() {
    // A - Impression Format Parametrable de FIP DND
    $('#idImprimerCreation').prop('disabled', true);
    setTimeout(() => {
      $('#idImprimerCreation').prop('disabled', false);
    }, 700)
    const societe: any = this.societe;
    if (societe.gestionFIP) {
      const obj: any = this.detail || {};
      const devis = this.detail || {};
      if (!obj.client.isNonSoumisFIP) {
        this.common.getListFIP((obj.client ? obj.client.id : 0), false, true).then(listfipdnd => {
          console.log(listfipdnd)
          this.isFipDNDDejaImprimer(devis, listfipdnd).then(existe => {
            if (!existe) {
              // imprimer FipDND
              this.isDD = false;
              if (this.existeDNDnonSignee()) {
                if (!societe.isFIPCET) {
                  this.common.openModal(this.modalService, this.confirmaFIPDND);
                } else {
                  this.avantAppelFormatPersoDND();
                }
              } else {
                this.gestionFIPDD();
              }
            } else {
              this.gestionFIPDD();
            }
          });
        });
      }
    }

  }

  gestionFIPDD() {
    // B - Impression Format Parametrable de FIP DD
    const societe: any = this.societe;
    if (societe.gestionFIP) {
      const obj: any = this.detail || {};
      const devis = this.detail || {};
      if (!obj.client.isNonSoumisFIP) {
        this.common.getListFIP(obj.client ? obj.client.id : 0, true, true).then(listfipdd => {
          this.isFipDDDejaImprimer(devis, listfipdd).then(existeDD => {
            if (!existeDD) {
              // imprimer FipDD
              this.isDD = true;
              if (this.existeDDnonSignee()) {
                if (!this.societe['isFIPCET']) {
                  this.common.openModal(this.modalService, this.confirmaFIPDD);
                } else {
                  this.avantAppelFormatPersoDD()
                }
              } else {
                this.getDetail(this.detail, true)
              }
            } else {
              // A ajouter getDetail
              this.getDetail(this.detail, true)
            }
          });
        });
      }

    }
  }

  nextClose() {
    if (!this.isDD) {
      this.gestionFIPDD();
    }
  }

  isFipDNDDejaImprimer(devis, listFipDND) {
    const listLigneNonDISArtAtester = this.recuperationArticleisNotDIS(devis);
    if (listLigneNonDISArtAtester.length > 0) {
      return this.parcoursListBonDND(devis, listFipDND, 0)
    } else {
      return Promise.resolve(true);
    }
  }

  recuperationArticleisNotDIS(devis) {
    const listLigneArtAtester = (devis.listLignes || []);
    return listLigneArtAtester.filter(Ligne => (Ligne.article && Ligne.article.id > 0 && !Ligne.article.isDIS && !Ligne.article.isNonSoumisFIP))
  }

  isFipDNDExistByNomenclature(ligne, devis, listFipDND) {
    // Le but de la fonction c'est de déterminer s'il y a déjà un FIP et un CAP lié à l'article de la ligne de devis (ID_FIP et ID_CAP)
    // Parcourir chaque ligne (FipDND) de l'étape 1
    let ID_FIP = 0;
    let isFipDNDExist = false;
    const annee = parseInt(moment(devis.dateCreation, 'DD/MM/YYYY').format('YYYY'), 10);
    const devisDateCreation = moment(devis.dateCreation, 'DD/MM/YYYY');
    const ligneSite = ligne.exutoire && ligne.exutoire.site ? ligne.exutoire.site.id || 0 : 0;
    listFipDND = listFipDND || []
    listFipDND.forEach(FipDND => {
      FipDND.clefSite = FipDND.clefSite || 0;
      if (!isFipDNDExist)
        if (FipDND.refusee && this.societe['isFIPCET']) {
          // alors on ne prend pas en compte la ligne FipDND
        } else if (FipDND.nomenclatureICPE &&
          FipDND.nomenclatureICPE.id === ligne.article.nomenclatureICPE.id
          && FipDND.client.id === devis.client.id) {
          if (this.societe['isFIPAnneeGlissante']) {
            // alors 5
            const fipDateCreation = moment(FipDND.dateCreation, 'DD/MM/YYYY HH:mm:ss');
            const fipDateCreationPlus1 = moment(FipDND.dateCreation, 'DD/MM/YYYY HH:mm:ss').add(1, 'year');

            if (fipDateCreation.isSameOrBefore(devisDateCreation) && devisDateCreation.isSameOrBefore(fipDateCreationPlus1)) {
              if (!this.societe['isFIPParSite']) {
                ID_FIP = FipDND.id;
                isFipDNDExist = true;

              } else if (FipDND.clefSite === ligneSite) {
                ID_FIP = FipDND.id;
                isFipDNDExist = true;
              }
            }
          } else if (FipDND.annee == annee) {
            // sinon 6
            if (!this.societe['isFIPParSite']) {
              ID_FIP = FipDND.id;
              isFipDNDExist = true;
            } else if (FipDND.clefSite === ligneSite) {
              ID_FIP = FipDND.id;
              isFipDNDExist = true;
            }
          }
        }
    });

    return ID_FIP;
  }

  isFipDNDExistByArticle(ligne, devis, listFipDND) {
    //     Le but de la fonction c'est de déterminer s'il y a déjà un FIP et un CAP lié à l'article de la ligne de devis (ID_FIP et ID_CAP)
    // Parcourir chaque ligne (FipDND) de l'étape 1
    let ID_FIP = 0;
    let isFipDNDExist = false;
    const annee = parseInt(moment(devis.dateCreation, 'DD/MM/YYYY').format('YYYY'), 10);
    const devisDateCreation = moment(devis.dateCreation, 'DD/MM/YYYY');
    listFipDND = listFipDND || [];
    const ligneSite = ligne.exutoire && ligne.exutoire.site ? ligne.exutoire.site.id || 0 : 0;
    listFipDND.forEach(FipDND => {
      FipDND.clefSite = FipDND.clefSite || 0;
      if (!isFipDNDExist)
        if (FipDND.refusee && this.societe['isFIPCET']) {
          // alors on ne prend pas en compte la ligne FipDND
        } else if (FipDND.article && FipDND.article.id === ligne.article.id
          && FipDND.client && devis.client && FipDND.client.id === devis.client.id
          && FipDND.chantier && devis.chantier && FipDND.chantier.id === devis.chantier.id) {
          if (this.societe['isFIPAnneeGlissante']) {
            // alors 5
            const fipDateCreation = moment(FipDND.dateCreation, 'DD/MM/YYYY HH:mm:ss');
            const fipDateCreationPlus1 = moment(FipDND.dateCreation, 'DD/MM/YYYY HH:mm:ss').add(1, 'year');

            if (fipDateCreation.isSameOrBefore(devisDateCreation) && devisDateCreation.isSameOrBefore(fipDateCreationPlus1)) {
              if (!this.societe['isFIPParSite']) {
                ID_FIP = FipDND.id;
                isFipDNDExist = true;
                // ID_CAP-> 7
              } else if (FipDND.clefSite === ligneSite) {
                ID_FIP = FipDND.id;
                isFipDNDExist = true;
                // ID_CAP-> 8
              }
            }
          } else if (FipDND.annee == annee) {
            // sinon 6
            if (!this.societe['isFIPParSite']) {
              ID_FIP = FipDND.id;
              isFipDNDExist = true;
              // ID_CAP-> 7
            } else if (FipDND.clefSite === ligneSite) {
              ID_FIP = FipDND.id;
              isFipDNDExist = true;
              // ID_CAP-> 8
            }
          }
        }
    });

    return ID_FIP;
  }

  parcoursListBonDND(devis, listFipDND, index) {
    let isExist = false;
    let ret = false;
    const societe: any = this.societe;
    const listLigneNonDISArtAtester = (devis.listLignes || []);
    if (index < listLigneNonDISArtAtester.length) {
      console.log('parcoursListBonDND index:' + index);
      const Ligne = listLigneNonDISArtAtester[index];
      const year = parseInt(moment().format('YYYY'), 10);
      const clefClient = devis.client ? devis.client.id : 0;
      const clefArticle = Ligne.article ? Ligne.article.id : 0;
      const clefChantier = devis.chantier ? devis.chantier.id : 0;
      const clefSiteCourant = this.common.user[2];
      const dtBon = devis.date;
      if (!this.societe['isFIPCET']) {
        // 2 - Récupération liste ligne devis avec article non DD et Parcourir la liste 2
        if (Ligne.article && Ligne.article.id > 0 && !Ligne.article.isDIS && Ligne.article.nomenclatureICPE
          && Ligne.article.nomenclatureICPE.id > 0) {
          let ID_FIP = this.isFipDNDExistByNomenclature(Ligne, devis, listFipDND);
          if (ID_FIP === 0) {
            ret = false;
            return Promise.resolve(ret);
          } else {
            // FipDND Exist
            return this.isFipDNDGetIDCAP(devis, Ligne).then(ID_CAP => {
              if (ID_CAP) {
                // Quand on va faire la gestion de CAP
                isExist = true;
                ret = true;
                return this.parcoursListBonDND(devis, listFipDND, index + 1);
              } else {
                isExist = true;
                ret = true;
                return this.parcoursListBonDND(devis, listFipDND, index + 1);
              }
            });
          }
        } else {
          ret = true;
          isExist = true;
          return this.parcoursListBonDND(devis, listFipDND, index + 1);
        }
      } else {

        // isFipDNDExistByArticle
        if (Ligne.article && Ligne.article.id > 0 && !Ligne.article.isDIS) {
          let ID_FIP = this.isFipDNDExistByArticle(Ligne, devis, listFipDND);

          if (ID_FIP === 0) {
            ret = false;
            return Promise.resolve(ret);
          } else {
            // FipDND Exist
            return this.isFipDNDGetIDCAP(devis, Ligne).then(ID_CAP => {
              if (ID_CAP) {
                // Quand on va faire la gestion de CAP
                isExist = true;
                ret = true;
                return this.parcoursListBonDND(devis, listFipDND, index + 1);
              } else {
                isExist = true;
                ret = true;
                return this.parcoursListBonDND(devis, listFipDND, index + 1);
              }
            });
          }
        } else {
          ret = true;
          isExist = true;
          // on passe à la ligne suivante pour vérifier si c'est un DND
          return this.parcoursListBonDND(devis, listFipDND, index + 1);
          // return Promise.resolve(ret);
        }
      }
    } else {
      return Promise.resolve(true);
    }
  }

  isFipDNDGetIDCAP(devis, ligne) {
    const param = {
      'servlet': 'DBGestionFipDND',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 12
        },
        'DATE_BON': {
          'typeParam': 'date',
          'valeur': devis.dateCreation
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': devis.client ? devis.client.id || 0 : 0
        },
        'CLEF_ARTICLE': {
          'typeParam': 'int',
          'valeur': ligne.article && ligne.article.id ? ligne.article.id : 0
        },
        'CLEF_CHANTIER': {
          'typeParam': 'int',
          'valeur': devis.chantier ? devis.chantier.id || 0 : 0
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': ligne.exutoire && ligne.exutoire.site && ligne.exutoire.site.id ? ligne.exutoire.site.id : 0
        },
        'CLEF_MODULE': {
          'typeParam': 'int',
          'valeur': 6
        }
      }
    };
    return this.common.post('', { param: param }, true).then(datas => {
      return datas.data;
    });
  }

  isFipDNDArticleExist(clefArticle, clefChantier, clefClient, anneeBon) {
    const param = {
      'servlet': 'DBGestionFipDND',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 9
        },
        'CLEF_ARTICLE': {
          'typeParam': 'int',
          'valeur': clefArticle
        },
        'ANNEE_BON': {
          'typeParam': 'int',
          'valeur': anneeBon
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': clefClient
        },
        'CLEF_CHANTIER': {
          'typeParam': 'int',
          'valeur': clefChantier
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': 0
        },
      }
    };
    return this.common.post('', { param: param }, true).then(datas => {
      return datas.data;
    });

  }

  isFipDDDejaImprimer(devis, listFipDD) {
    const listLigneNonDISArtAtester = this.recuperationArticleisDIS(devis);

    if (listLigneNonDISArtAtester.length > 0) {
      return this.parcoursListBonDD(devis, listFipDD, 0)
    } else {
      return Promise.resolve(true);
    }
  }

  recuperationArticleisDIS(devis) {
    const listLigneArtAtester = (devis.listLignes || []);
    return listLigneArtAtester.filter(Ligne => (Ligne.article && Ligne.article.id > 0 && Ligne.article.isDIS && !Ligne.article.isNonSoumisFIP))
  }

  isFipDDExistByArticle(ligne, devis, listFipDD) {
    // Le but de la fonction c'est de déterminer s'il y a déjà un FIP et un CAP lié à l'article de la ligne de devis (ID_FIP et ID_CAP)
    // Parcourir chaque ligne (FipDD) de l'étape 1
    let ID_FIP = 0;
    let isFipDDExist = false;
    const annee = parseInt(moment(devis.dateCreation, 'DD/MM/YYYY').format('YYYY'), 10);
    const devisDateCreation = moment(devis.dateCreation, 'DD/MM/YYYY');
    const ligneSite = ligne.exutoire && ligne.exutoire.site ? ligne.exutoire.site.id || 0 : 0;
    listFipDD = listFipDD || []
    listFipDD.forEach(FipDD => {
      FipDD.clefSite = FipDD.clefSite || 0;
      if (!isFipDDExist)
        if (FipDD.refusee && this.societe['isFIPCET']) {
          // alors on ne prend pas en compte la ligne FipDD
        } else if (FipDD.article && FipDD.article.id === ligne.article.id
          && FipDD.client && devis.client && FipDD.client.id === devis.client.id
          && FipDD.chantier && devis.chantier && FipDD.chantier.id === devis.chantier.id) {
          if (this.societe['isFIPAnneeGlissante']) {
            // alors 5
            const fipDateCreation = moment(FipDD.dateCreation, 'DD/MM/YYYY HH:mm:ss');
            const fipDateCreationPlus1 = moment(FipDD.dateCreation, 'DD/MM/YYYY HH:mm:ss').add(1, 'year');

            if (fipDateCreation.isSameOrBefore(devisDateCreation) && devisDateCreation.isSameOrBefore(fipDateCreationPlus1)) {
              if (!this.societe['isFIPParSite']) {
                ID_FIP = FipDD.id;
                isFipDDExist = true;
                // ID_CAP-> 7
              } else if (FipDD.clefSite === ligneSite) {
                ID_FIP = FipDD.id;
                isFipDDExist = true;
                // ID_CAP-> 8
              }
            }
          } else if (FipDD.annee == annee) {
            // sinon 6
            if (!this.societe['isFIPParSite']) {
              ID_FIP = FipDD.id;
              isFipDDExist = true;
              // ID_CAP-> 7
            } else if (FipDD.clefSite === ligneSite) {
              ID_FIP = FipDD.id;
              isFipDDExist = true;
              // ID_CAP-> 8
            }
          }
        }
    });

    return ID_FIP;
  }

  parcoursListBonDD(devis, listFipDD, index) {
    let retour = false;
    let isExist = false;
    const listLigneNonDISArtAtester = (devis.listLignes || []);
    if (index < listLigneNonDISArtAtester.length) {
      console.log('parcoursListBonDD index:' + index);
      const Ligne = listLigneNonDISArtAtester[index];
      if (Ligne.article && Ligne.article.isDIS && Ligne.article.id > 0) {
        // isFipDDExistByArticle
        const ID_FIP = this.isFipDDExistByArticle(Ligne, devis, listFipDD);
        if (ID_FIP === 0) {
          retour = false;
          return Promise.resolve(retour);
        } else {
          return this.isFipDDGetIDCAP(Ligne, devis).then(ID_CAP => {
            if (ID_CAP) {
              // Quand on va faire la gestion de CAP
              isExist = true;
              retour = true;
              return this.parcoursListBonDD(devis, listFipDD, index + 1);
            } else {
              isExist = true;
              retour = true;
              return this.parcoursListBonDD(devis, listFipDD, index + 1)
            }
          })
        }
      } else {
        retour = true;
        isExist = true;
        return this.parcoursListBonDD(devis, listFipDD, index + 1)
      }
    } else {
      return Promise.resolve(true);
    }
  }

  isFipDDGetIDCAP(ligne, devis) {
    const param = {
      'servlet': 'DBGestionFipDD',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 10
        },
        'DATE_BON': {
          'typeParam': 'date',
          'valeur': devis.dateCreation
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': devis.client ? devis.client.id || 0 : 0
        },
        'CLEF_ARTICLE': {
          'typeParam': 'int',
          'valeur': ligne.article && ligne.article.id ? ligne.article.id : 0
        },
        'CLEF_CHANTIER': {
          'typeParam': 'int',
          'valeur': devis.chantier ? devis.chantier.id || 0 : 0
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': ligne.exutoire && ligne.exutoire.site && ligne.exutoire.site.id ? ligne.exutoire.site.id : 0
        },
        'CLEF_MODULE': {
          'typeParam': 'int',
          'valeur': 6
        }
      }
    };
    return this.common.post('', { param: param }, true).then(datas => {
      return datas.data;
    });
  }

  ouvrirRenseignementsFIPDD(devis) {
    this.devisFIP = devis;
    this.isDD = true;
    this.recuperationListFIP();

  }

  ouvrirRenseignementsFIP(devis) {
    this.devisFIP = devis;
    this.isDD = false;
    this.recuperationListFIP();
  }

  getdetailArticleContenu(row, event, rowIndex) {
    row.articleContenantContenu = event;
    this.actualiseArticleApres(row, ('.artCont' + rowIndex))
    this.detailArticleContenu(event.id).then((res) => {
      if (res && res.length) {
        let detail = res[0]
        row['articleContenantContenu'].code = detail.code || '',
          row['articleContenantContenu'].libelle = detail.libelle || ''
      }
    })
  }

  detailArticleContenu(id) {
    const clef = '' + id;
    const param = {
      'servlet': 'DBGetArticle',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetArticle', clef]
    };
    return this.common.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }

  recuperationListFIP() {

    const user = this.common.local.getObject('userDetail') || {};
    this.listFIP = {};
    this.devisFIP = this.devisFIP || {}
    let param: any = {};


    this.isEmpty = false;
    this.devisFIP['nomclass'] = 'Devis';
    param = {
      'servlet': this.isDD ? 'DBGestionFipDD' : 'DBGestionFipDND',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'forcerSerialisation': 'true',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 7
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.devisFIP['client'] ? this.devisFIP['client'].id || '0' : 0
        },

        'ANNEE_BON': {
          'typeParam': 'int',
          'valeur': moment(this.devisFIP['dateCreation'], 'DD/MM/YYYY').format('YYYY')
        },
        'DEVIS': this.devisFIP,
      }
    };

    if (this.isDD) {
      param.data['CLEF_CHANTIER'] = {
        'typeParam': 'int',
        'valeur': this.devisFIP['chantier'] ? this.devisFIP['chantier'].id || '0' : 0
      };
    }


    return this.common.post('', { param: param }).then(datas => {
      // $('#empty').trigger('click');
      const listFIP = [];

      if (this.isDD) {
        (datas.data || []).filter(row => {
          if ((row.article && row.article.id)) {
            listFIP.push(row);
          }
        });
      } else {
        (datas.data || []).filter(row => {
          if (this.societe['isFIPCET'] || (row.nomenclatureICPE && row.nomenclatureICPE.id)) {
            listFIP.push(row);
          }
        });
      }


      if (listFIP.length) {
        this.common.openModal(this.modalService, this.gestFIP, true);
      } else {
        this.nextFIPClose();
      }

      this.listFIP = datas;
      return datas.data;
    });
  }

  showFicheclt: boolean = false;
  createClient() {
    this.common.closeModal()
    this.showFicheclt = !this.showFicheclt
  }

  closeCreateClt() {
    // this.addClient = false;
    this.showFicheclt = false;

  }

  afterAddClt(event) {
    this.getDetailClient(event.id, true).then(data => {
      console.log(data);
      if (data) {
        data.libelleObjetEntite = (data.prospect ? data.codeProspect : data.codeClient) + ' / ' + data.nomClient;
        data.type = 'Client';
        data.table = 'clients';
        const filtress = [{ ...data }];
        this.common.filtreDevisDupliquerClient = filtress
        this.dupClientSelected = data
        this.common.openModal(this.modalService, this.dialogueDupliquer);
      }
    });
  }

  getDetailClient(id, notClient?) {
    const param = {
      'servlet': 'DBGetClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': id
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'LOAD_CHANTIER': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };
    if (id) {
      return this.common.post('', { param: param }, notClient || false).then(datas => {
        if (datas.data) {
          this.clientProsp = datas.data[0];
          this.clientProsp['codeBlocage'] = this.common.getCodeBlocageClient(this.clientProsp, parseInt(this.common.user[2], 10));
          this.common.getEncoursClient(this.clientProsp)
          return datas.data[0];
        }
      });
    } else {
      return Promise.resolve();
    }
  }


  keyEnterTabQte(row) {
    if (this.societe['gestionFIP']) {
      row.showQteANInput = true;
    } else {
      row.showPUInput = true;
    }
  }
  existeDDnonSignee() {
    const existeFIPDd = this.recuperationArticleisDIS(this.detail)
    return existeFIPDd.some(ligne => ligne.fipDD && !ligne.fipDD.signee);
  }

  existeDNDnonSignee() {
    const existeFIPDND = this.recuperationArticleisNotDIS(this.detail);
    return existeFIPDND.some(ligne => ligne.fipDND && !ligne.fipDND.signee);
  }

  avantAcceptDevisFIP() {
    const devis = this.detail;
    devis['nomclass'] = 'Devis';
    const param = {
      'servlet': 'DBGestionFip',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'DEVIS': devis,
      }
    };
    if (this.societe['gestionFIP'] && this.societe['isFIPCET']) {
      return this.common.post('', { param: param }, true).then(datas => {
        if (datas.data && !datas.message) {
          this.acceptationDevisFIP();
        }
      });
    } else {
      this.acceptationDevisFIP()
    }

  }
}

